import React, { useState, useEffect, useMemo, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import { Container, Form, Button, Row, Col, Card } from "react-bootstrap";
import { Modal } from "react-bootstrap";
import { useParams, useLocation } from "react-router-dom";
import "react-datepicker/dist/react-datepicker.css";
import { useNavigate } from "react-router-dom";
import {
  fetchRestaurantDetails,
  tablesToChange as fetchTablesToChange,
  fetchConnectTablesConfig,
  changeTables,
  fetchTables,
} from "../actions/restaurantActions";
import "react-phone-input-2/lib/style.css";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";
import { ToastContainer } from "react-toastify";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import TablesModal from "../components/ChangeTables";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTriangleExclamation,
  faClock,
  faHouse,
  faCalendarAlt,
  faUsers,
  faNoteSticky,
} from "@fortawesome/free-solid-svg-icons";
import {
  fetchOpenTime,
  fetchCreateReservation,
  fetchReservationLimitPeopleBaby,
  fetchEditReservation,
  fetchReservationCustomerMenu,
  checkIfrestaurantIsOpenToday,
  getRestaurantTimeZone,
  ResetReservation,
  fetchCancelReservation,
  fetchReservationActive,
} from "../actions/reservationsActions";
import styled from "styled-components";
import CustomDatePicker from "../components/CustomDatePicker";
import CustomSelect from "../components/SelectableCustom";
import Loader from "../components/Loader";
import {
  effectiveIntervalPeopleLimit,
  effectiveReservationPartyLimit,
} from "../utils/planFeatures";
import TermsAndConditions from "../components/TermsAndConditions";
import ScrollInputOptions from "../components/ScrollInputOptions";
import StepThreeReservations from "../components/StepThreeReservations";
import AnimatedCheck from "../components/CheckMarkAnimation";
import { isValidNumber } from "libphonenumber-js";
import StepBar from "../components/StepBar";
import NumberOfPeopleSelector from "../components/NumberOfPeopleSelector";
import ChooseTime from "../components/ChooseTime";
import moment from "moment-timezone";
import { is } from "date-fns/locale";
import { TableSvgIcon } from "../icons/SvgIcons";
import { ModernButton, ModalOverlay } from "../components/DefaultImports";
import { ConfirmationModal } from "../components/ConfirmationModal";
import SwitchOnAndOff from "../components/SwitchOnAndOff";
import SoupAttribution from "../components/SoupAttribution";
const WidgetScreenFrame = styled.div`
  width: 100%;
  /* The twin of the Wrapper's old fixed height. In the restaurant's modal a
     600px box held a 660px form with overflow visible, so the last 60px sat
     outside anything the modal body counted as scrollable: unreachable, with
     the sticky action bar parked over it. */
  height: ${({ $widgetMode, $fromRestaurant }) => {
    if ($widgetMode) return "100%";
    return $fromRestaurant ? "auto" : "600px";
  }};
  max-height: ${({ $widgetMode }) => ($widgetMode ? "100%" : "none")};
  display: ${({ $widgetMode }) => ($widgetMode ? "flex" : "block")};
  flex-direction: ${({ $widgetMode }) => ($widgetMode ? "column" : "initial")};
  overflow: ${({ $widgetMode }) => ($widgetMode ? "hidden" : "visible")};
  background: ${({ $widgetMode, $backgroundColor }) =>
    $widgetMode ? $backgroundColor : "transparent"};
  color: ${({ $widgetDark }) => ($widgetDark ? "#f6f1e8" : "#333333")};
  box-sizing: border-box;
  padding: 0;
`;
const Wrapper = styled(Container)`
  width: ${({ no_border, $widgetMode }) =>
    no_border || $widgetMode ? "100%" : "auto"};

  /* Bootstrap's own .container rule matches this element too and wins on
     source order, so the 500px was never applied: the customer's form spread
     across the whole viewport with the calendar stranded at the left edge.
     Stated with intent, and centred rather than merely narrow. */
  ${({ no_border, $widgetMode }) =>
    !no_border && !$widgetMode
      ? `
        width: 100% !important;
        max-width: 560px !important;
        margin-left: auto !important;
        margin-right: auto !important;
      `
      : ""}

  ${({ $widgetMode }) => ($widgetMode ? "max-width: 720px;" : "")}

  --widget-main-color: ${({ $mainColor }) => $mainColor || "#ee754c"};
  --widget-bg: ${({ $widgetMode, $backgroundColor }) =>
    $widgetMode ? $backgroundColor : "#ffffff"};
  --widget-text-color: ${({ $widgetMode, $isDark }) =>
    $widgetMode && $isDark ? "#f6f1e8" : "#343a38"};
  --widget-muted-text: ${({ $widgetMode, $isDark }) =>
    $widgetMode && $isDark ? "rgba(246, 241, 232, 0.68)" : "#6f7c79"};
  --widget-border-color: ${({ $widgetMode, $isDark }) =>
    $widgetMode && $isDark
      ? "rgba(255, 255, 255, 0.18)"
      : "rgba(153, 176, 173, 0.32)"};
  --widget-soft-bg: ${({ $widgetMode, $isDark }) =>
    $widgetMode && $isDark ? "rgba(255, 255, 255, 0.08)" : "#fafafa"};

  margin: ${({ no_border, $widgetMode }) => {
    if (no_border) return "0";
    return $widgetMode ? "0 auto" : "24px auto";
  }};
  background-color: var(--widget-bg);
  color: var(--widget-text-color);
  padding: ${({ no_border, $widgetMode }) => {
    if (no_border) return "0 !important";
    return $widgetMode ? "16px !important" : "20px 20px 24px";
  }};
  border-radius: ${({ $widgetMode, $radius }) =>
    $widgetMode ? `${$radius}px` : "16px"};
  box-shadow: ${({ no_border, $widgetMode }) =>
    no_border || $widgetMode ? "none" : "0 18px 44px rgba(75, 51, 53, 0.1)"};
  border: ${({ no_border, $widgetMode }) =>
    no_border || $widgetMode ? "none" : "1px solid #ece6de"};

  /* The widget fills its frame and the public page keeps its fixed canvas. The
     restaurant's modal is given a window-height dialog by Bootstrap's
     scrollable flag, so the form fills it and hands the leftover space to the
     action bar at its foot - rather than the fixed 600px that used to leave a
     band of white under the last field. */
  min-height: ${({ $widgetMode, from_restaurant }) => {
    if ($widgetMode) return "0";
    return from_restaurant ? "100%" : "540px";
  }};
  height: ${({ $widgetMode, from_restaurant }) => {
    if ($widgetMode) return "100%";
    return "auto";
  }};
  max-height: ${({ $widgetMode }) => ($widgetMode ? "100%" : "none")};

  box-sizing: border-box;
  display: ${({ $widgetMode, from_restaurant }) =>
    $widgetMode || from_restaurant ? "flex" : "block"};
  flex-direction: ${({ $widgetMode, from_restaurant }) =>
    $widgetMode || from_restaurant ? "column" : "initial"};
  overflow: ${({ $widgetMode }) => ($widgetMode ? "hidden" : "visible")};

  @media (max-width: 576px) {
    padding: ${({ no_border, $widgetMode }) => {
      if (no_border) return "0 !important";
      return $widgetMode ? "10px !important" : "14px 14px 18px";
    }};

    /* A phone has no room to spend on a floor that keeps a card from
       resizing, and none to spare at the edges either. */
    ${({ no_border, $widgetMode }) =>
      !no_border && !$widgetMode
        ? `
          min-height: 0;
          margin: 12px auto !important;
          max-width: calc(100% - 20px) !important;
          border-radius: 12px;
        `
        : ""}
  }
`;
const ModalBackgroundCheck = styled.div`
  width: 50px;
  height: 50px;
  z-index: 1002;
`;
const ContainerCheck = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 50;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
`;
const Title = styled.h3`
  width: 100%;
  margin: ${({ $widgetMode }) => ($widgetMode ? "4px 0 14px" : "0 0 20px")};
  font-size: ${({ $widgetMode }) => ($widgetMode ? "1.25rem" : "1.45rem")};
  font-weight: 750;
  text-transform: ${({ $widgetMode }) => ($widgetMode ? "none" : "uppercase")};
  color: ${({ $mainColor }) => $mainColor || "var(--app-orange, #ee754c)"};
  text-align: center;
  line-height: 1.2;
`;
/* Small, centred and quiet: the restaurant's name is the title here, and this
   only says what the page is for. */
const Eyebrow = styled.p`
  margin: 0 0 6px;
  text-align: center;
  font-size: 11px;
  font-weight: 750;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: #a8bbb8;
`;

const WidgetHeading = styled.div`
  width: 100%;
  flex-shrink: 0;
  overflow-wrap: anywhere;
  text-align: center;
  margin-bottom: 8px;
`;
const WidgetCustomTitle = styled.div`
  width: 100%;
  color: ${({ $mainColor }) => $mainColor || "#ee754c"};
  font-size: 1.05rem;
  font-weight: 750;
  line-height: 1.45;
  margin-bottom: 4px;
`;
/* The restaurant takes bookings over the phone with the guest waiting, so the
   whole form is on one page rather than behind four wizard steps.

   Deliberately flat: a small label with a hairline under it and the content
   beneath. The controls already carry their own framing, so wrapping them in
   cards produced boxes inside boxes. */
const FormGrid = styled.div`
  /* On the customer widget this wrapper must not exist as far as layout is
     concerned: the card there is a flex column and the step content has to stay
     a direct flex item of it. display:contents makes the box disappear while
     keeping the element in the tree. */
  ${({ $single }) => !$single && "display: contents;"}

  ${({ $single }) =>
    $single &&
    `
      width: 100%;
      display: grid;
      /* Every control in this form starts at the same left edge - the card
         around it stays centred for the confirmation screen that follows. */
      text-align: left;

      /* The modal header already provides the space above the first section. */
      > section:first-child > h3 {
        margin-top: 0;
      }
      /* Two columns only when each one has real room. Splitting a 700px modal
         in half left the people and time controls too narrow for their own
         contents and they were clipped. The min() is what keeps this honest on
         a phone: a bare 390px minimum cannot shrink below 390px, so the grid
         grew wider than the modal and pushed every row off the edge. */
      grid-template-columns: repeat(auto-fit, minmax(min(390px, 100%), 1fr));
      column-gap: 32px;
      row-gap: 2px;
      align-items: start;
    `}
`;

const Section = styled.section`
  min-width: 0;

  ${({ $span }) => $span && "grid-column: 1 / -1;"}
`;

const SectionLabel = styled.h3`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 8px 0 4px;
  padding-bottom: 5px;
  border-bottom: 1px solid #efe9e2;
  font-size: 10.5px;
  font-weight: 750;
  letter-spacing: 0.09em;
  text-transform: uppercase;
  color: #a8bbb8;

  svg {
    font-size: 11px;
  }
`;

/* The calendar is by far the tallest thing on the form and is touched once per
   booking, so it lives behind a field that opens it - the way a date input
   behaves anywhere else. */
const DateField = styled.button`
  width: 100%;
  height: 32px;
  padding: 0 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  border: 1px solid ${({ $open }) => ($open ? "#ee754c" : "#e2ded7")};
  border-radius: 8px;
  background: #ffffff;
  color: #3f4c48;
  font-size: 12.5px;
  font-weight: 650;
  cursor: pointer;
  text-align: left;

  &:hover:not(:disabled) {
    border-color: #ee754c;
  }

  &:disabled {
    cursor: default;
  }

  svg {
    color: #a8bbb8;
    font-size: 11px;
  }
`;

/* Wraps only the field it belongs to, so a popover hung off it opens against
   the field rather than against whatever the surrounding layout has grown to. */
const DatePopoverAnchor = styled.div`
  position: relative;
`;

const DatePopover = styled.div`
  position: absolute;
  z-index: 40;
  top: calc(100% + 6px);
  left: 0;
  width: min(330px, 92vw);
  padding: 6px;
  border: 1px solid #ece6de;
  border-radius: 12px;
  background: #ffffff;
  box-shadow: 0 18px 44px rgba(75, 51, 53, 0.18);
`;

/* Room on the left, time on the right - two ordinary fields side by side, with
   no section heading above them because the field labels already say what they
   are. */
const PairRow = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  align-items: start;
  gap: 8px 14px;

  @media (max-width: 420px) {
    gap: 6px 10px;
  }
`;

const FieldBlock = styled.div`
  position: relative;
  min-width: 0;

  /* A room and a time only mean something once there is a day to hang them on,
     and the times are fetched per date anyway. Until then the pair stays
     visible but inert, so the form keeps its shape instead of jumping. */
  ${({ $disabled }) =>
    $disabled &&
    `
      opacity: 0.42;
      pointer-events: none;
    `}
`;

const PairHint = styled.p`
  grid-column: 1 / -1;
  display: flex;
  align-items: center;
  gap: 6px;
  margin: 2px 0 0;
  font-size: 11px;
  font-weight: 600;
  color: #a8bbb8;

  svg {
    font-size: 10px;
  }
`;

const FieldLabel = styled.span`
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 8px 0 4px;
  padding-bottom: 5px;
  border-bottom: 1px solid #efe9e2;
  font-size: 10.5px;
  font-weight: 750;
  letter-spacing: 0.09em;
  text-transform: uppercase;
  color: #a8bbb8;

  svg {
    font-size: 11px;
  }
`;

/* Wider than the field it hangs off, so it is anchored to that field's right
   edge and grows back across the form. Anchored left it ran past the side of
   the modal and gave the whole dialog a horizontal scrollbar. */
const TimePopover = styled.div`
  position: absolute;
  z-index: 40;
  top: calc(100% + 6px);
  right: 0;
  left: auto;
  width: min(460px, calc(100vw - 56px));
  min-width: 100%;
  max-height: min(360px, 58vh);
  overflow: hidden auto;
  padding: 4px;
  border: 1px solid #ece6de;
  border-radius: 12px;
  background: #ffffff;
  box-shadow: 0 18px 44px rgba(75, 51, 53, 0.18);
`;

/* Two choices, so a segmented pill rather than a dropdown carrying two very
   long sentences. The values it sets are the same strings as before, because
   the table-assignment logic keys off them. */
const Segmented = styled.div`
  display: inline-flex;
  padding: 2px;
  border-radius: 999px;
  background: #f4f7f6;
  box-shadow: inset 0 0 0 1px rgba(153, 176, 173, 0.3);
`;

const SegmentedOption = styled.button`
  padding: 0 12px;
  height: 26px;
  border: 0;
  border-radius: 999px;
  background: ${({ $active }) => ($active ? "#ee754c" : "transparent")};
  color: ${({ $active }) => ($active ? "#ffffff" : "#6f7c79")};
  font-size: 11.5px;
  font-weight: 700;
  cursor: pointer;
  white-space: nowrap;
  transition:
    background-color 0.14s ease,
    color 0.14s ease;

  &:hover {
    color: ${({ $active }) => ($active ? "#ffffff" : "#ee754c")};
  }
`;

const FormSection = ({
  single,
  icon,
  title,
  span = false,
  // Some sections label their own fields, so the heading would just be noise.
  bare = false,
  children,
}) => {
  if (!single) return <>{children}</>;

  return (
    <Section $span={span}>
      {!bare && (
        <SectionLabel>
          <FontAwesomeIcon icon={icon} />
          {title}
        </SectionLabel>
      )}
      {children}
    </Section>
  );
};

const StyledCard = styled.div`
  width: 100%;
  min-width: 0;

  ${({ from_restaurant, $widgetMode }) =>
    !from_restaurant && !$widgetMode
      ? `
        max-width: 100%;
        margin-left: auto;
        margin-right: auto;
      `
      : ""}

  background-color: ${({ $widgetMode, $backgroundColor }) =>
    $widgetMode ? $backgroundColor : "white"};
  color: ${({ $widgetMode, $isDark }) =>
    $widgetMode && $isDark ? "#f6f1e8" : "#343a38"};
  padding: ${({ from_restaurant, $widgetMode }) =>
    from_restaurant || $widgetMode ? "0 !important" : "10px"};
  border-radius: ${({ $widgetMode }) => ($widgetMode ? "12px" : "5px")};
  border: none;
  box-shadow: none;
  box-sizing: border-box;
  text-align: center;

  ${({ $widgetMode, from_restaurant }) =>
    $widgetMode
      ? `
        flex: 1 1 auto;
        min-height: 0;
        height: auto;
        max-height: 100%;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: stretch;
        align-content: stretch;
        flex-wrap: nowrap;
      `
      : from_restaurant
        ? `
        /* Grows to fill a tall modal so the action bar can sit at its foot,
           but never shrinks below its own content: with shrink enabled and a
           definite height above it, this box was sized to the modal instead of
           to the form. Everything past that height then spilled out of the
           scrollable area - unreachable, with the sticky bar parked on top of
           it. */
        flex: 1 0 auto;
        height: auto;
        overflow: visible;
        display: flex;
        flex-direction: column;
        align-items: stretch;
      `
        : `
        min-height: 385px;
        height: auto;
        overflow: visible;
        display: flex;
        justify-content: center;
        align-items: flex-start;
        align-content: flex-start;
        flex-wrap: wrap;
      `}

  & > * {
    margin: 0;
    margin-bottom: ${({ $widgetMode, from_restaurant }) =>
      $widgetMode || from_restaurant ? "0" : "10px"};
  }
`;
const ActionButtons = styled.div`
  margin-top: 20px;
  display: flex;
  gap: 10px;
`;
const DivFlexEnd = styled.div`
  display: flex;
  width: 100%;
  justify-content: end;
`;
const DivFlexStart = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: start;
`;
const Extras = styled.div`
  width: 100%;
  min-height: 42px;
  display: flex;
  align-items: center;
  padding: 9px 12px;
  margin-top: 4px;
  border-radius: 10px;
  gap: 10px;
  border: ${(props) =>
    props.isExtrasOpen ? "1px solid #EE754C" : "1px solid #d8dddb"};
  justify-content: space-between;
  cursor: pointer;
  color: ${(props) => (props.isExtrasOpen ? "#ffffff" : "#343a38")};
  background-color: ${(props) => (props.isExtrasOpen ? "#EE754C" : "white")};
  box-sizing: border-box;
`;
const CustomDateContainer = styled.div`
  position: fixed;
  width: auto;
  height: auto;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -70%);
  z-index: 5000;
`;
const ModalBackgroundToCustomDate = styled.div`
  position: fixed;
  z-index: 1005;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.5);
`;
/* The assignment mode and, when it is manual, the picker that mode summons -
   one row at the height of the controls above it, rather than a second line
   that appears and shifts everything under it. */
/* Everything the form can decide sits in one bar in the bottom-right corner
   of the modal, and stays there: it sticks to the foot of the scroll area, so
   a long form never hides the button that finishes it. */
const FormActions = styled.div`
  position: sticky;
  bottom: 0;
  z-index: 6;
  width: 100%;
  /* Takes the column's leftover space, so it sits on the modal's bottom edge
     when the form is short and rides the scroll when it is long. */
  margin-top: auto;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 10px;
  padding: 14px 0 2px;
  background: #ffffff;
  border-top: 1px solid #f1ece7;
`;

/* Sits to the left of the buttons rather than under them: it is the reason
   the button is grey, so it belongs on the same line as the button. */
const ActionHint = styled.span`
  margin-right: auto;
  min-width: 0;
  text-align: left;
  white-space: nowrap;
  font-size: 11.5px;
  font-weight: 600;
  line-height: 1.3;
  color: #d94b4b;
`;

const AssignmentRow = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  /* The action bar's margin-top is auto, which collapses to nothing once the
     form is tall enough to scroll - so the gap above it has to come from
     here, or this row ends up against the Criar Reserva button. */
  margin-bottom: 12px;
`;

const TablesWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 6px;
  min-width: 0;
`;

const TableNames = styled.span`
  min-width: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 12px;
  font-weight: 700;
  color: #5d6b67;
`;

const SmallButton = styled.button`
  height: 26px;
  padding: 0 12px;
  border: 1px solid #d7ded9;
  border-radius: 999px;
  background: #ffffff;
  color: #5d6b67;
  font-size: 11.5px;
  font-weight: 700;
  white-space: nowrap;
  cursor: pointer;
  transition:
    border-color 0.14s ease,
    color 0.14s ease;

  &:hover:not(:disabled) {
    border-color: var(--app-orange, #ee754c);
    color: var(--app-orange, #ee754c);
  }

  &:disabled {
    opacity: 0.45;
    cursor: not-allowed;
  }
`;
const TableBox = styled.div`
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f79574;
  color: white;
  font-size: 13px;
  font-weight: 500;
  border-radius: 4px;
  border: 1px solid gray;
`;
function getTableInfo(selectedTablesList, allTablesList) {
  let tableInfo = {};
  Object.keys(selectedTablesList).forEach((zoneName) => {
    const tableNumbers = selectedTablesList[zoneName].map(
      (table) => table.number,
    );
    allTablesList.forEach((tablesInZone) => {
      if (tablesInZone[0] === zoneName) {
        tableNumbers.forEach((tableNumber) => {
          const tableDetails = tablesInZone.find(
            (table) => table.split(";")[0] === tableNumber,
          );
          if (tableDetails) {
            if (tableInfo[zoneName]) {
              tableInfo[zoneName].push(tableDetails);
            } else {
              tableInfo[zoneName] = [tableDetails];
            }
          }
        });
      }
    });
  });
  let tableInfoList = [];
  Object.keys(tableInfo).forEach((zone) => {
    tableInfoList.push([zone, ...tableInfo[zone]]);
  });
  return tableInfoList;
}
function getTableInfoPk(selectedTablesList) {
  let tablePKs = [];
  Object.values(selectedTablesList).forEach((tablesInZone) => {
    tablesInZone.forEach((table) => {
      tablePKs.push(String(table.number));
    });
  });
  return tablePKs;
}
function listToSelectedTablesFormat(zoneName, tableNumbers) {
  if (!Array.isArray(tableNumbers)) {
    throw new Error("Expected parameter to be an array");
  }
  const tables = tableNumbers.map((tableNumber) => ({
    number: tableNumber,
    status: "0",
  }));
  return {
    [zoneName]: tables,
  };
}
const NO_ROOM_OPTION = "Não definir sala";
const NO_ROOM_ALIASES = new Set([
  "não definir sala",
  "sem sala",
]);

function isNoRoomOption(value) {
  return NO_ROOM_ALIASES.has(String(value ?? "").trim().toLowerCase());
}

function normalizeRoomSelection(value, fromRestaurant) {
  const normalizedValue = String(value ?? "").trim();
  if (!normalizedValue || isNoRoomOption(normalizedValue)) {
    return fromRestaurant ? NO_ROOM_OPTION : "";
  }
  return value;
}

const ReservationScreen = ({
  from_restaurant = false,
  creating = true,
  isEditModalOpen = false,
  setIsEditModalOpen = false,
  restaurantId = false,
  token_from_restaurant = false,
  handleCloseReservationModal,
  setCreating,
  reset,
  editModalRef,
  setTokens = false,
  reservation_or_waiting_list = "reservation",
  setReservationHasBeenModified,
  reservationHasBeenModified,
  modalReservationModifyReservation,
  setModalReservationModifyReservation,
  no_border = false,
  reservationRetry = false,
  setReservationRetry,
  widgetMode: widgetModeProp = false,
  widgetDark = false,
}) => {
  const { t, i18n: i18nInstance } = useTranslation();
  const id = useParams();
  const location = useLocation();
  const queryParams = useMemo(() => {
    return new URLSearchParams(location.search);
  }, [location.search]);
  const isValidCssColor = (value) => {
    if (!value) return false;
    return (
      /^#[0-9A-Fa-f]{6}$/.test(value) ||
      /^rgb\(\s*\d{1,3}\s*,\s*\d{1,3}\s*,\s*\d{1,3}\s*\)$/.test(value) ||
      /^rgba\(\s*\d{1,3}\s*,\s*\d{1,3}\s*,\s*\d{1,3}\s*,\s*(0|1|0?\.\d+)\s*\)$/.test(
        value,
      )
    );
  };
  const normalizeCssColor = (value, fallback) => {
    return isValidCssColor(value) ? value : fallback;
  };
  const widgetSettings = {
    title: queryParams.get("title") || t("ui.i18nFinalCleanup.bookTable"),
    showRestaurantName: queryParams.get("showName") !== "0",
    mainColor: normalizeCssColor(
      queryParams.get("main") ||
        queryParams.get("primary") ||
        queryParams.get("button"),
      "#EE754C",
    ),
    backgroundColor: normalizeCssColor(queryParams.get("bg"), "#FFFFFF"),
    radius: Number(queryParams.get("radius") || 14),
  };
  const routeToken =
    id.token && id.token !== "no_token" && id.token !== "null"
      ? id.token
      : false;
  const routeWidgetMode = id.from_whom === "widget";
  const widgetMode = Boolean(widgetModeProp || routeWidgetMode);

  // The widget, and the public booking link a restaurant shares. Everything
  // else using this component - the restaurant's own booking screen, the guest's
  // edit modal - is not a place to put the Soup mark.
  const isDinerFacingSurface =
    widgetMode || (!from_restaurant && !isEditModalOpen && !no_border);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [token, setToken] = useState(
    token_from_restaurant ? token_from_restaurant : routeToken,
  );
  const [restaurant_id, setRestaurant_id] = useState(
    id.restaurant_id ? id.restaurant_id : restaurantId,
  );
  const [startDateWS, setStartDateWS] = useState(false);
  const [babyChairs, setBabyChairs] = useState(false);
  const [numBabyChairs, setNumBabyChairs] = useState(0);
  const [time, setTime] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [numPeople, setNumPeople] = useState(0);
  const [estimatedTime, setEstimatedTime] = useState("");
  const [message, setMessage] = useState("");
  const [restaurantNote, setRestaurantNote] = useState("");
  const maxMessageLength = 150;
  const [accessability, setAccessability] = useState("");
  /* Asked only where the restaurant has turned the question on - see
     ask_pet_friendly / ask_baby_stroller in its settings. */
  const [bringsPet, setBringsPet] = useState(false);
  const [bringsStroller, setBringsStroller] = useState(false);
  const [accessabilities, setAccessabilities] = useState(["Cadeira de rodas"]);
  const [tablesUsed, setTablesUsed] = useState([]);
  const [usedTablesDic, setUsedTablesDic] = useState({});
  const [fullName, setFullName] = useState("");
  const [placeOfTable, setPlaceOfTable] = useState("");
  const [placeOfTableWS, setPlaceOfTableWS] = useState(false);
  const [fourthStage, setFourthStage] = useState(false);
  const [errorMessage, setErrorMessage] = useState(false);
  const [countryCode, setCountryCode] = useState("us");
  const [countryCodeNumber, setCountryCodeNumber] = useState("351");
  const [phone, setPhone] = useState("");
  const [phoneWithoutCountryCode, setPhoneWithoutCountryCode] = useState("");
  const [email, setEmail] = useState("");
  const [emailWS, setTheEmailWS] = useState(false);
  const [has_email, setHas_email] = useState(false);
  const [subscription, setSubscription] = useState({});
  const [cd, setCd] = useState("");
  const [showTermsAndConditions, setShowTermsAndConditions] = useState(false);
  const [acceptTerms, setAcceptTerms] = useState(false);
  const [acceptTermsWS, setAcceptTermsWS] = useState(false);
  const [hasAttemptedSubmit, setHasAttemptedSubmit] = useState(false);
  const [showDateModal, setShowDateModal] = useState(false);
  const [fullRestaurant, setFullRestaurant] = useState(false);
  const [isExtrasOpen, setIsExtrasOpen] = useState(false);
  const [isMessageOpen, setIsMessageOpen] = useState(false);
  const [isAccessOpen, setIsAccessOpen] = useState(false);
  const [showCheck, setShowCheck] = useState(false);
  const [editingStartFalse, setEditingStartFalse] = useState(true);
  const [showTablesModal, setShowTablesModal] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [ignoreLimitations, setIgnoreLimitations] = useState(false);
  const [selectedTablesSave, setSelectedTablesSave] = useState(false);
  const [isTablesChangedManually, setIsTablesChangedManually] = useState(false);
  const [isReservationChanged, setIsReservationChanged] = useState(false);
  const [accept_and_notify_client, setAccept_and_notify_client] =
    useState(false);
  const [accept_edit_modal, setAccept_edit_modal] = useState(false);
  const [verifyReservationFields, setVerifyReservationFields] = useState(false);
  const [enoughSeatsReservation, setEnoughSeatsReservation] = useState(false);
  const [modalWarningNotEnoughSeats, setModalWarningNotEnoughSeats] =
    useState(false);
  const [showModalWarning, setShowModalWarning] = useState(false);
  const [showPrepaymentConfirmation, setShowPrepaymentConfirmation] =
    useState(false);
  const [acceptPrepaymentPolicy, setAcceptPrepaymentPolicy] = useState(false);
  const [fullyBooked, setFullyBooked] = useState(false);
  const [isChangesMade, setIsChangesMade] = useState(false);
  const [isAlertFullyBookedOrCrowd, setIsAlertFullyBookedOrCrowd] =
    useState(false);
  const [autoOrManualTables, setAutoOrManualTables] = useState(
    creating ? "Atribuição automática de mesas" : "Atribuição manual de mesas",
  );
  const [update, setUpdate] = useState(0);
  const reservationCancel = useSelector((state) => state.cancelReservation);
  const { cancelMessage, isLoadingCancel } = reservationCancel;
  const reservation_info = useSelector(
    (state) => state.reservationCustomersMenu,
  );
  const {
    reservation,
    isLoading: isLoadingReservation = false,
    error: reservationLoadError = false,
  } = reservation_info;
  const editReservations = useSelector((state) => state.editReservation);
  const { editReservation, isLoadingEditReservation } = editReservations;
  const openTimes = useSelector((state) => state.openTime);
  const { openTime, isLoadingOpenTime, errorOpenTime } = openTimes;
  const LimitsPB = useSelector((state) => state.reservationLimitsPeopleBaby);
  const { limitPeopleBaby } = LimitsPB;
  const reservation_createdd = useSelector((state) => state.createReservation);
  const {
    reservation_created,
    toastCreateUpdate,
    isLoading,
    error,
    createReservationFailed,
    createReservationSuccess,
  } = reservation_createdd;
  const restaurantDetails = useSelector((state) => state.restaurantDetails);
  const {
    restaurants,
    isLoading: isLoadingRestaurant = false,
    error: restaurantLoadError = false,
  } = restaurantDetails;
  const prepaymentUnitAmountCents = Math.max(
    0,
    Number(restaurants?.prepayment_amount_cents) || 0,
  );
  const prepaymentMinimumPeople = Math.max(
    1,
    Number(restaurants?.prepayment_min_people) || 1,
  );
  const customerPrepaymentRequired = Boolean(
    creating &&
      !from_restaurant &&
      restaurants?.prepayment_active &&
      Number(numPeople) >= prepaymentMinimumPeople &&
      prepaymentUnitAmountCents > 0,
  );
  const prepaymentTotalCents =
    restaurants?.prepayment_charge_type === "fixed"
      ? prepaymentUnitAmountCents
      : prepaymentUnitAmountCents * Math.max(0, Number(numPeople) || 0);
  const formatPrepaymentMoney = (amountCents) =>
    new Intl.NumberFormat(undefined, {
      style: "currency",
      currency: "EUR",
    }).format((Number(amountCents) || 0) / 100);
  const tablesToChange = useSelector((state) => state.availableTablesToChange);
  const { tables = [], isLoadingTables, errorTables } = tablesToChange;
  const all_tables_wait = useSelector((state) => state.restaurantTables);
  const { tables: all_tables = false, isLoading: isLoadingAllTables = false } =
    all_tables_wait;
  const [initialLoading, setInitialLoading] = useState(true);

  const normalizedToken = token ? String(token) : "";
  const reservationMatchesCurrentToken = Boolean(
    reservation &&
      (!normalizedToken ||
        !reservation.token ||
        String(reservation.token) === normalizedToken),
  );
  const currentReservation =
    !creating && normalizedToken && reservationMatchesCurrentToken
      ? reservation
      : null;

  const restaurantMatchesCurrentId = Boolean(
    restaurants &&
      (!restaurant_id ||
        Number(restaurants.id) === Number(restaurant_id)),
  );
  const restaurantTimezone = restaurants?.timezone || "Europe/Lisbon";
  const restaurantReservationLimit = effectiveReservationPartyLimit(
    restaurants,
    restaurants?.limit_people_reservation,
  );
  const restaurantPeoplePerTime = effectiveIntervalPeopleLimit(
    restaurants,
    restaurants?.accept_people_per_each_time,
  );
  const restaurantSubscriptionLevel = Number(restaurants?.sub_lvl ?? 0);
  const reservationStatus = currentReservation?.status ?? "";
  const roomOptions = useMemo(() => {
    const realZones = Array.isArray(openTime?.zones)
      ? openTime.zones.filter((zone) => !isNoRoomOption(zone))
      : [];

    if (
      from_restaurant &&
      reservation_or_waiting_list === "waiting_list"
    ) {
      return [NO_ROOM_OPTION, ...realZones];
    }

    return realZones;
  }, [openTime?.zones, from_restaurant, reservation_or_waiting_list]);

  const reservationDataReady = creating || Boolean(currentReservation);
  const restaurantDataReady = restaurantMatchesCurrentId;
  const shouldRenderReservationForm =
    (creating || isEditModalOpen) &&
    !initialLoading &&
    reservationDataReady &&
    restaurantDataReady;
  const hasReservationLoadError = Boolean(
    !creating &&
      !isLoadingReservation &&
      !currentReservation &&
      reservationLoadError,
  );
  const hasRestaurantLoadError = Boolean(
    !isLoadingRestaurant && !restaurantDataReady && restaurantLoadError,
  );
  const hasEditLoadError =
    (creating || isEditModalOpen) &&
    (hasReservationLoadError || hasRestaurantLoadError);

  const [notifyCustomerModal, setNotifyCustomerModal] = useState(false);
  const [isSubmittingNotifyChoice, setIsSubmittingNotifyChoice] =
    useState(false);
  useEffect(() => {
    if (reservationRetry === true) {
      const reservationInfo = error?.reservationInfo;
      if (reservationInfo) {
        setFullName(reservationInfo.name);
        const dateObject = new Date(reservationInfo.date);
        setStartDate(dateObject);
        setPlaceOfTable(
          normalizeRoomSelection(
            reservationInfo.placeOfTables,
            from_restaurant,
          ),
        );
        setTime(reservationInfo.time);
        setEstimatedTime(reservationInfo.estimatedtime);
        setMessage(reservationInfo.message);
        setNumPeople(reservationInfo.numberOfPeople);
        setCountryCodeNumber(reservationInfo.country_code);
        setPhone(reservationInfo.phone_number);
        setEmail(reservationInfo.email);
        setSelectedTablesSave(false);
        setAccessability(
          reservationInfo.accessability === "wheel_chair"
            ? "Cadeira de rodas"
            : "Não precisa",
        );
        setBringsPet(Boolean(reservationInfo.brings_pet));
        setBringsStroller(Boolean(reservationInfo.brings_stroller));
        setRestaurantNote(reservationInfo.restaurant_note);
        setNumBabyChairs(reservationInfo.baby_chair);
        setBabyChairs(reservationInfo.baby_chair > 0);
        if (reservationInfo.accessability !== "not_needed") {
          setIsAccessOpen(true);
        } else {
          setIsAccessOpen(false);
        }
      }
      setCurrentStep(3);
    }
  }, [error, from_restaurant, reservationRetry]);
  useEffect(() => {
    const timer = setTimeout(() => {
      setInitialLoading(false);
    }, 500);
    return () => clearTimeout(timer);
  }, []);
  useEffect(() => {
    if (!from_restaurant) {
      dispatch(fetchReservationActive());
    }
  }, [from_restaurant]);
  useEffect(() => {
    if (
      Array.isArray(tablesUsed) &&
      tablesUsed[0] == "" &&
      tablesUsed.length > 1
    ) {
      setTablesUsed(tablesUsed.slice(1, tablesUsed.length));
    }
  }, [tablesUsed]);
  useEffect(() => {
    if (token) {
      setEditingStartFalse(true);
    } else {
      setEditingStartFalse(true);
    }
  }, [token, editingStartFalse]);
  useEffect(() => {
    dispatch(fetchTables(restaurant_id));
    dispatch(fetchConnectTablesConfig(restaurant_id));
  }, [restaurants]);
  useEffect(() => {
    if (restaurantId) {
      setRestaurant_id(restaurantId);
    }
  }, [restaurantId]);
  const getDateInTimezone = (timezone) => {
    const now = new Date();
    const dateInTimezone = new Date(
      now.toLocaleString("en-US", {
        timeZone: timezone,
      }),
    );
    dateInTimezone.setHours(0, 0, 0, 0);
    return dateInTimezone;
  };
  const getTimezone = (timezone) => {
    const now = new Date();
    const dateInTimezone = new Date(
      now.toLocaleString("en-US", {
        timeZone: timezone,
      }),
    );
    const hours = dateInTimezone.getHours().toString().padStart(2, "0");
    const minutes = dateInTimezone.getMinutes().toString().padStart(2, "0");
    return `${hours}:${minutes}`;
  };
  const isWithinOneDay = (reservationDate) => {
    const now = new Date();
    const reservation = new Date(reservationDate);
    if (isNaN(reservation)) {
      return false;
    }
    now.setHours(0, 0, 0, 0);
    reservation.setHours(0, 0, 0, 0);
    const diffInMs = reservation - now;
    const diffInDays = diffInMs / (1000 * 60 * 60 * 24);
    return diffInDays >= -1;
  };
  useEffect(() => {
    if (!reservation && reservationRetry === false) {
      if (!creating && token) return;
      setToken("");
      setEstimatedTime("");
      setBabyChairs(false);
      setNumBabyChairs(0);
      setMessage("");
      setEmail("");
      setNumPeople(0);
      setTablesUsed([]);
      setSelectedTablesSave(false);
      setAccessability("");
      setBringsPet(false);
      setBringsStroller(false);
      setPlaceOfTable("");
      setUsedTablesDic({});
      setStartDate(null);
      setTime(null);
      setRestaurantNote("");
      if (restaurants && reservation_or_waiting_list === "waiting_list") {
        setStartDate(getDateInTimezone(restaurantTimezone));
        setPlaceOfTable(from_restaurant ? NO_ROOM_OPTION : "");
        setTime(getTimezone(restaurantTimezone));
        setCurrentStep(1);
      } else {
        setCurrentStep(0);
      }
      if (from_restaurant) {
        setFullName("");
        setPhoneWithoutCountryCode("");
      }
    }
  }, [creating, token, reservation_or_waiting_list, reservation]);
  const [fullNameWS, setFullNameWS] = useState(false);
  const [numPeopleWS, setNumPeopleWS] = useState(false);
  const [timeWS, setTimeWS] = useState(false);
  const [phoneWS, setPhoneWS] = useState(false);
  useEffect(() => {
    dispatch(checkIfrestaurantIsOpenToday(restaurant_id));
    dispatch(getRestaurantTimeZone(restaurant_id));
  }, [from_restaurant, restaurant_id]);
  useEffect(() => {
    if (!restaurant_id || !startDate || !time || !numPeople) return;
    dispatch(
      fetchReservationLimitPeopleBaby(
        restaurant_id,
        startDate,
        time,
        numPeople,
        token || "no_token",
      ),
    );
  }, [startDate, time, restaurant_id, numPeople, token]);
  const [currentStep, setCurrentStep] = useState(0);
  useEffect(() => {
    if (!creating) {
      setCurrentStep(3);
    }
  }, []);
  const parseTime = (timeString) => {
    if (
      !timeString ||
      typeof timeString !== "string" ||
      !timeString.includes(":")
    ) {
      console.warn("⛔ Invalid time string passed to parseTime:", timeString);
      return NaN;
    }
    const [hours, minutes] = timeString.split(":").map(Number);
    return hours * 60 + minutes;
  };
  useEffect(() => {
    if (!restaurant_id || isLoadingRestaurant) return;
    if (
      !restaurants ||
      Number(restaurants.id) !== Number(restaurant_id)
    ) {
      dispatch(fetchRestaurantDetails(restaurant_id));
    }
  }, [
    dispatch,
    restaurant_id,
    restaurants?.id,
    isLoadingRestaurant,
  ]);
  useEffect(() => {
    if (token_from_restaurant) {
      setToken(token_from_restaurant);
    } else {
      setToken(routeToken);
    }
    if (!reservation) {
      setSelectedTablesSave(false);
    }
  }, [token_from_restaurant, routeToken, reservation]);
  useEffect(() => {
    if (!creating && token != "") {
      dispatch(fetchReservationCustomerMenu(token, "no"));
    } else {
      dispatch(ResetReservation());
    }
  }, [creating, token]);
  useEffect(() => {
    if (!creating && token !== "" && currentReservation) {
      if (Number(restaurant_id) !== Number(currentReservation.restaurant)) {
        setRestaurant_id(currentReservation.restaurant);
      }
    }
  }, [creating, token, currentReservation, restaurant_id]);
  useEffect(() => {
    if (!currentReservation) return;

    const safeCountryCode = String(
      currentReservation.country_code ?? "351",
    );
    let safePhoneNumber = String(currentReservation.phone_number ?? "");
    if (safePhoneNumber.startsWith("+")) {
      safePhoneNumber = safePhoneNumber.slice(1);
    }
    const phoneWithoutCountryCode = safePhoneNumber.slice(
      safeCountryCode.length,
    );
    const safeTablesUsed = String(currentReservation.tablesused ?? "")
      .split(",")
      .map((tableNumber) => tableNumber.trim())
      .filter(Boolean);

    setFullName(currentReservation.full_name ?? "");

    const dateObject = currentReservation.date
      ? new Date(currentReservation.date)
      : null;
    if (dateObject && !Number.isNaN(dateObject.getTime())) {
      setStartDate(dateObject);
    }

    setPlaceOfTable(
      normalizeRoomSelection(
        currentReservation.table_place_preference?.place_of_table,
        from_restaurant,
      ),
    );
    setTime(currentReservation.time ?? null);
    setEstimatedTime(currentReservation.estimatedtime ?? "");
    setMessage(currentReservation.message ?? "");
    setNumPeople(Number(currentReservation.number_of_people ?? 0));
    setTablesUsed(safeTablesUsed);
    setCountryCodeNumber(safeCountryCode);
    setPhone(String(currentReservation.phone_number ?? ""));
    setPhoneWithoutCountryCode(phoneWithoutCountryCode);
    setEmail(currentReservation.email ?? "");
    setHas_email(Boolean(currentReservation.email?.trim()));
    setSelectedTablesSave(false);
    setAccessability(
      currentReservation.accessability === "wheel_chair"
        ? "Cadeira de rodas"
        : "Não precisa",
    );
    setBringsPet(Boolean(currentReservation.brings_pet));
    setBringsStroller(Boolean(currentReservation.brings_stroller));
    setRestaurantNote(currentReservation.restaurant_note ?? "");
    setNumBabyChairs(Number(currentReservation.baby_chair ?? 0));
    setBabyChairs(Number(currentReservation.baby_chair ?? 0) > 0);
    setIsAccessOpen(currentReservation.accessability !== "not_needed");

    if (dateObject && !Number.isNaN(dateObject.getTime())) {
      dispatch(
        fetchTablesToChange(
          currentReservation.restaurant,
          `${dateObject.getFullYear()}-${String(
            dateObject.getMonth() + 1,
          ).padStart(2, "0")}-${String(dateObject.getDate()).padStart(
            2,
            "0",
          )}`,
          currentReservation.time,
          currentReservation.token,
          currentReservation.number_of_people,
        ),
      );
    }
  }, [currentReservation, dispatch, from_restaurant]);

  useEffect(() => {
    if (!currentReservation) return;

    const usedTables = String(currentReservation.tablesused ?? "")
      .split(",")
      .map((tableNumber) => tableNumber.trim())
      .filter(Boolean);
    const selectedTablesFormat = listToSelectedTablesFormat(
      normalizeRoomSelection(
        currentReservation.table_place_preference?.place_of_table,
        from_restaurant,
      ),
      usedTables,
    );
    setUsedTablesDic(selectedTablesFormat);
  }, [currentReservation, from_restaurant]);
  useEffect(() => {
    console.log(
      "i was selectedTablesSave: ",
      selectedTablesSave,
      "usedTablesDic: ",
      usedTablesDic,
    );
  }, [selectedTablesSave, usedTablesDic]);
  const handleShowTablesModal = (show = true) => {
    let usedTablesss = tablesUsed;
    let selectedTablesFormat = {};
    if (Array.isArray(usedTablesss)) {
      selectedTablesFormat = listToSelectedTablesFormat(
        placeOfTable,
        usedTablesss,
      );
    }
    setUsedTablesDic(selectedTablesFormat);
    const inputDate = new Date(startDate);
    dispatch(
      fetchTablesToChange(
        restaurant_id,
        `${inputDate.getFullYear()}-${String(inputDate.getMonth() + 1).padStart(2, "0")}-${String(inputDate.getDate()).padStart(2, "0")}`,
        time,
        token === "" ? "no_token" : token,
        numPeople,
      ),
    );
    if (show) {
      setShowTablesModal(true);
    }
  };
  /* Restaurant side shows the whole form at once; the customer widget keeps its
     step-by-step flow. Step 4 is the result screen either way, so the form
     sections close once it is reached. */
  const singlePage = Boolean(from_restaurant);
  const [isDatePickerOpen, setIsDatePickerOpen] = useState(false);
  const [isTimePickerOpen, setIsTimePickerOpen] = useState(false);
  /* Set when a party size is chosen, cleared once the room has been settled.
     It has to be state rather than a ref: the work happens in an effect that
     waits for the day's zones to arrive, and a ref would not wake it. */
  const [autoSelectRoomPending, setAutoSelectRoomPending] = useState(false);
  const autoOpenedDateRef = useRef(false);
  const datePopoverRef = useRef(null);
  const timePopoverRef = useRef(null);

  /* A dialog opened from inside a popover - the time list's "Aviso", say - is
     portaled to the end of the body, so by DOM containment it is *outside* the
     popover that owns it. Every mousedown on it therefore read as a click
     elsewhere and closed the popover, unmounting the dialog before its button
     could fire a click: the warning vanished and nothing happened.

     A click inside any dialog that does not itself contain the popover belongs
     to something stacked on top of it, and must leave it alone. Clicks in the
     host modal around the popover still close it, as before. */
  const clickIsInsideNestedDialog = (event, anchorNode) => {
    const dialog = event.target?.closest?.(".modal, [role='dialog']");
    return Boolean(dialog && anchorNode && !dialog.contains(anchorNode));
  };

  useEffect(() => {
    if (!isDatePickerOpen) return undefined;

    const closeOnOutside = (event) => {
      if (!datePopoverRef.current) return;
      if (datePopoverRef.current.contains(event.target)) return;
      if (clickIsInsideNestedDialog(event, datePopoverRef.current)) return;
      setIsDatePickerOpen(false);
    };

    const closeOnEscape = (event) => {
      if (event.key === "Escape") setIsDatePickerOpen(false);
    };

    document.addEventListener("mousedown", closeOnOutside);
    document.addEventListener("keydown", closeOnEscape);

    return () => {
      document.removeEventListener("mousedown", closeOnOutside);
      document.removeEventListener("keydown", closeOnEscape);
    };
  }, [isDatePickerOpen]);

  useEffect(() => {
    if (!isTimePickerOpen) return undefined;

    const closeOnOutside = (event) => {
      if (!timePopoverRef.current) return;
      if (timePopoverRef.current.contains(event.target)) return;
      if (clickIsInsideNestedDialog(event, timePopoverRef.current)) return;
      setIsTimePickerOpen(false);
    };

    const closeOnEscape = (event) => {
      if (event.key === "Escape") setIsTimePickerOpen(false);
    };

    document.addEventListener("mousedown", closeOnOutside);
    document.addEventListener("keydown", closeOnEscape);

    return () => {
      document.removeEventListener("mousedown", closeOnOutside);
      document.removeEventListener("keydown", closeOnEscape);
    };
  }, [isTimePickerOpen]);

  // Picking a time is the last thing done in that popover, so it closes itself.
  useEffect(() => {
    if (time) setIsTimePickerOpen(false);
  }, [time]);

  /* A booking taken over the phone starts with "which day?", so the calendar is
     already open when the form appears rather than waiting to be found. Once
     only: reopening it whenever it closes would trap anyone who shut it to
     look at the rest of the form. A door queue is always for right now and
     comes in with its date already set, so it is left alone. */
  useEffect(() => {
    if (!singlePage || !creating) return;
    if (reservation_or_waiting_list !== "reservation") return;
    if (autoOpenedDateRef.current || startDate) return;
    autoOpenedDateRef.current = true;
    setIsDatePickerOpen(true);
  }, [singlePage, creating, reservation_or_waiting_list, startDate]);

  /* A single room is not a choice worth presenting. Taking it saves a tap for
     the restaurant and, for the customer, means the step stops asking a
     question with one answer and goes straight to the times. */
  useEffect(() => {
    if (placeOfTable) return;
    if (roomOptions.length !== 1) return;

    const onlyRoom = roomOptions[0];
    if (isNoRoomOption(onlyRoom)) return;

    setPlaceOfTable(onlyRoom);
  }, [roomOptions, placeOfTable]);

  /* Party size is the last thing that changes which rooms can take the booking,
     so choosing it settles the room and moves straight on to the time list.
     The first room that is not full, and only when none has been picked by
     hand - an explicit choice is never overruled. If the zones for that day
     have not arrived yet this simply waits for them. */
  useEffect(() => {
    if (!autoSelectRoomPending) return;
    if (!roomOptions.length) return;

    setAutoSelectRoomPending(false);

    if (!placeOfTable) {
      const firstFree = roomOptions.find(
        (zone) => !String(zone).endsWith("/f"),
      );
      setPlaceOfTable(firstFree || roomOptions[0]);
    }

    setIsTimePickerOpen(true);
  }, [autoSelectRoomPending, roomOptions, placeOfTable]);

  const selectedDateLabel = startDate
    ? new Date(startDate).toLocaleDateString((i18nInstance && i18nInstance.language) || "pt", {
        weekday: "short",
        day: "numeric",
        month: "short",
        year: "numeric",
      })
    : t("ui.screens.reservationScreen.sectionDate");
  /* Both the room and the time hang off the chosen day - the times are even
     fetched per date - so neither is offered before there is one. */
  const dateChosen = Boolean(startDate);
  const formDataReady =
    !isLoading &&
    !isLoadingEditReservation &&
    !isLoadingOpenTime &&
    !isLoadingReservation &&
    !isLoadingAllTables &&
    !initialLoading;
  /* Choosing tables by hand needs a day, a time and a party size: the endpoint
     that lists free tables is keyed on all three. Called without a time it
     fails, the reducer sets `tables` to false, and the modal below then does
     not render at all - which left the screen dimmed behind a dialog that
     never arrived. So the button is only live once it can work. */
  const canPickTables = dateChosen && Boolean(time) && numPeople !== 0;
  // What the manual picker has already been given, named rather than numbered.
  const chosenTableNames =
    Array.isArray(tablesUsed) && tablesUsed.length > 0 && tablesUsed[0] !== ""
      ? tablesUsed
          .map((num) => parseInt(num, 10))
          .sort((a, b) => a - b)
          .map((tableNumber) => {
            const tableObj = all_tables?.find(
              (table) => table.id === tableNumber,
            );
            return tableObj ? tableObj.table_name : tableNumber;
          })
          .join(", ")
      : "";
  const showFormStep = (step) =>
    singlePage ? currentStep < 4 : currentStep === step;

  const changeStep = (step) => {
    if (step === 0) {
      setCurrentStep(step);
      if (!from_restaurant) {
        setStartDate(null);
        setTime(null);
        setNumPeople(0);
        setPlaceOfTable("");
      }
    }
    if (step === 1 && startDate != null) {
      setCurrentStep(step);
      if (!from_restaurant) {
        setTime(null);
        setNumPeople(0);
        setPlaceOfTable("");
      }
      setStartDateWS(false);
    } else {
      setStartDateWS(true);
    }
    if ((step === 2 && numPeople != "") || from_restaurant) {
      setCurrentStep(step);
    }
    if (step === 3 && time != "" && placeOfTable != "") {
      setCurrentStep(step);
      setTimeWS(false);
      setPlaceOfTableWS(false);
    } else {
      setTimeWS(true);
      setPlaceOfTableWS(true);
    }
  };
  const goBack = () => {
    if (currentStep === 3) {
      setErrorMessage(false);
    }
    setCurrentStep(currentStep - 1);
  };
  const verifyEmptyFields = (verify_for_edition = false) => {
    let verifyFields = true;
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!from_restaurant && !emailRegex.test(email.trim())) {
      setTheEmailWS(true);
      verifyFields = false;
    } else {
      setTheEmailWS(false);
    }
    if (time === "" || time === null) {
      verifyFields = false;
      setTimeWS(true);
    } else {
      setTimeWS(false);
    }
    if (fullName === "") {
      verifyFields = false;
      setFullNameWS(true);
    } else {
      setFullNameWS(false);
    }
    if (placeOfTable === "") {
      verifyFields = false;
      setPlaceOfTableWS(true);
    } else {
      setPlaceOfTableWS(false);
    }
    if (isValidNumber("+" + phone) || from_restaurant) {
      setPhoneWS(false);
    } else {
      verifyFields = false;
      setPhoneWS(true);
    }
    if (numPeople === 0) {
      verifyFields = false;
      setNumPeopleWS(true);
    } else {
      setNumPeopleWS(false);
    }
    if (!verify_for_edition) {
      if (acceptTerms === false && from_restaurant === false) {
        verifyFields = false;
        setAcceptTermsWS(true);
      } else {
        setAcceptTermsWS(false);
      }
    }
    return verifyFields;
  };
  useEffect(() => {
    if (verifyEmptyFields()) {
      setVerifyReservationFields(true);
    } else {
      setVerifyReservationFields(false);
    }
  }, [startDate, numPeople, time, placeOfTable, fullName, email, phone]);
  /* The customer's form arrived with every field already outlined in red,
     which reads as "you did something wrong" before anything has been typed.
     The checks themselves are unchanged - only whether they are shown - and
     the restaurant still sees them straight away, because its submit button is
     disabled until the form is valid and the outlines are the only thing
     saying which field is missing. */
  const showFieldErrors = from_restaurant || hasAttemptedSubmit;

  const handleSubmit = async (e, prepaymentConfirmed = false) => {
    setHasAttemptedSubmit(true);
    e?.preventDefault?.();
    let verifyFields = verifyEmptyFields();
    if (verifyFields === true) {
      if (customerPrepaymentRequired && !prepaymentConfirmed) {
        setAcceptPrepaymentPolicy(false);
        setShowPrepaymentConfirmation(true);
        return;
      }

      setShowPrepaymentConfirmation(false);
      const tables_used_list = getTableInfoPk(selectedTablesSave);
      const createdReservation = await dispatch(
        fetchCreateReservation(
          restaurant_id,
          startDate,
          numPeople,
          "Discontinued shift field",
          time,
          fullName,
          email,
          phone,
          countryCodeNumber,
          babyChairs ? numBabyChairs : 0,
          message,
          placeOfTable.endsWith("/f") || placeOfTable.endsWith("/b")
            ? placeOfTable.slice(0, -2)
            : placeOfTable,
          subscription,
          accessability === "Cadeira de rodas" ? "wheel_chair" : "not_needed",
          from_restaurant,
          reservation_or_waiting_list,
          autoOrManualTables === "Atribuição automática de mesas"
            ? "automatic"
            : "not_automatic",
          tables_used_list,
          restaurantNote,
          Boolean(customerPrepaymentRequired && prepaymentConfirmed),
          bringsPet,
          bringsStroller,
        ),
      );

      // Do not move the customer to the final/reload screen when the backend
      // failed to create the reservation or Stripe Checkout Session. Keeping
      // them on the form lets them retry after the real error is surfaced.
      if (!createdReservation) {
        return;
      }

      setCurrentStep((previousStep) => previousStep + 1);
      if (creating === true && from_restaurant) {
        setCreating(false);
      }
      setShowCheck(true);
      setTimeout(() => {
        setShowCheck(false);
      }, 1700);

      if (setIsEditModalOpen != false) {
        setIsEditModalOpen(false);
      }
      if (setTokens != false) {
        setTokens("");
      }
    }
  };
  const handleCheckWarningBeforeEdit = (e) => {
    e.preventDefault();
    if (
      !enoughSeatsReservation &&
      autoOrManualTables === "Atribuição manual de mesas"
    ) {
      setModalWarningNotEnoughSeats(true);
    } else if (isAlertFullyBookedOrCrowd) {
      setShowModalWarning(true);
    } else {
      if (creating) {
        handleSubmit(e);
      } else {
        if (
          from_restaurant &&
          (reservationStatus === "pending_restaurant" ||
            reservationStatus === "edited")
        ) {
          setAccept_edit_modal(true);
        } else {
          handleEdit(e);
        }
      }
    }
  };
  const shouldAskRestaurantEditNotifyModal = () => {
    if (!from_restaurant || creating) return false;
    if (
      reservationStatus === "pending_restaurant" ||
      reservationStatus === "edited"
    ) {
      return false;
    }
    return true;
  };
  const submitEditReservation = async (e, notifyCustomer = false) => {
    if (e && typeof e.preventDefault === "function") {
      e.preventDefault();
    }
    let verifyFields = verifyEmptyFields(true);
    if (verifyFields !== true) return;
    toast(t("ui.i18nMessages.reservationEdited"), {
      autoClose: 1000,
      zIndex: 1000,
    });
    setShowCheck(true);
    setTimeout(() => {
      setShowCheck(false);
    }, 1700);
    setCurrentStep(currentStep + 1);
    const tables_used_list = getTableInfoPk(selectedTablesSave);
    if (isReservationChanged && currentReservation) {
      dispatch(
        fetchEditReservation(
          token,
          restaurant_id,
          currentReservation.id,
          startDate,
          numPeople,
          "Discontinued shift field",
          time,
          fullName,
          phone,
          countryCodeNumber,
          numBabyChairs,
          message,
          placeOfTable.endsWith("/f") || placeOfTable.endsWith("/b")
            ? placeOfTable.slice(0, -2)
            : placeOfTable,
          subscription,
          accessability === "Cadeira de rodas" ? "wheel_chair" : "not_needed",
          ignoreLimitations,
          from_restaurant,
          from_restaurant && !creating ? true : isTablesChangedManually,
          tables_used_list,
          restaurantNote,
          notifyCustomer,
          email,
          bringsPet,
          bringsStroller,
        ),
      );
    }
    if (!creating && token != "") {
      dispatch(fetchReservationCustomerMenu(token, "no"));
    } else {
      dispatch(ResetReservation());
    }
    setIsEditModalOpen(!isEditModalOpen);
    if (from_restaurant) {
      setTokens("");
    }
  };
  const handleNotifyCustomerChoice = async (notifyCustomer) => {
    try {
      setIsSubmittingNotifyChoice(true);
      setNotifyCustomerModal(false);
      await submitEditReservation(null, notifyCustomer);
    } finally {
      setIsSubmittingNotifyChoice(false);
    }
  };
  const handleEdit = (e) => {
    if (e && typeof e.preventDefault === "function") {
      e.preventDefault();
    }
    let verifyFields = verifyEmptyFields(true);
    if (verifyFields !== true) return;
    if (shouldAskRestaurantEditNotifyModal()) {
      setNotifyCustomerModal(true);
      return;
    }
    const notifyCustomer =
      from_restaurant &&
      !creating &&
      (reservationStatus === "pending_restaurant" ||
        reservationStatus === "edited")
        ? accept_and_notify_client
        : false;
    submitEditReservation(e, notifyCustomer);
  };
  useEffect(() => {
    if (!restaurant_id || !startDate || !numPeople) return;
    dispatch(
      fetchOpenTime(
        restaurant_id,
        startDate,
        numPeople,
        token === "no_id" ? false : token,
        ignoreLimitations,
      ),
    );
    if (initialLoading) return;
    const dateObject = new Date(startDate);
    if (Number.isNaN(dateObject.getTime())) return;
    if (!time) return;
    const formattedDate = `${dateObject.getFullYear()}-${String(dateObject.getMonth() + 1).padStart(2, "0")}-${String(dateObject.getDate()).padStart(2, "0")}`;
    const realToken =
      creating || !currentReservation
        ? "no_token"
        : currentReservation.token;
    const t = setTimeout(() => {
      dispatch(
        fetchTablesToChange(
          restaurant_id,
          formattedDate,
          time,
          realToken,
          numPeople,
        ),
      );
    }, 450);
    return () => clearTimeout(t);
  }, [
    dispatch,
    restaurant_id,
    startDate,
    numPeople,
    token,
    ignoreLimitations,
    time,
    initialLoading,
    creating,
    reservation,
  ]);
  const handleTimeChange = (newTime) => {
    setTime(newTime);
  };
  const handlePlaceOfTable = (value) => {
    // setTablesUsed([]);
    setPlaceOfTable(value);
    // setSelectedTablesSave([]);
    // setUsedTablesDic({});
  };
  const handlePeopleChange = (value) => {
    setNumPeople(value);
  };
  const handleBabyChange = (value) => {
    setNumBabyChairs(value);
  };
  const handleBabyReset = (value) => {
    setNumBabyChairs(0);
  };
  useEffect(() => {
    if (
      reservation_created &&
      currentStep >= 4 &&
      reservation_created.token &&
      !from_restaurant &&
      createReservationFailed === false
    ) {
      if (
        reservation_created.payment_required &&
        reservation_created.payment_checkout_url
      ) {
        window.location.href = reservation_created.payment_checkout_url;
        return;
      }
      navigate(
        `/customer_reservation_menu/${reservation_created.token}/await_confirmation`,
      );
    }
  }, [
    currentStep,
    reservation_created,
    createReservationFailed,
    from_restaurant,
    navigate,
  ]);
  const handleGoToReservationWhenEdited = () => {
    navigate(
      `/customer_reservation_menu/${editReservation.token}/await_confirmation`,
    );
  };
  const handleGoBackToReservationsRestaurantMenu = () => {
    navigate(`/reservationfromrestaurant/${restaurant_id}`);
  };
  const handleNotificationSubscription = (sub) => {
    setSubscription(sub);
  };
  useEffect(() => {
    if (countryCodeNumber && phoneWithoutCountryCode.length >= 0) {
      setPhone(String(countryCodeNumber) + String(phoneWithoutCountryCode));
    }
  }, [phoneWithoutCountryCode, countryCodeNumber]);
  const handleTermsAndConditionsFalse = () => {
    setShowTermsAndConditions(false);
  };
  const handleOpenDateModal = () => {
    setShowDateModal(true);
  };
  const handleCloseDateModal = () => {
    setShowDateModal(false);
  };
  useEffect(() => {
    if (
      openTime &&
      Array.isArray(openTime.zones) &&
      creating &&
      from_restaurant
    ) {
      let foundZoneWithoutF = false;
      let foundShiftWithoutF = false;
      if (!foundZoneWithoutF) {
        setFullRestaurant(true);
      } else {
        setFullRestaurant(false);
      }
    }
  }, [openTime, numPeople]);
  const handleExtras = (value) => {
    setIsExtrasOpen(!isExtrasOpen);
  };
  const handleTablesUsedChange = (value) => {
    setTablesUsed(value);
  };
  const handleCancel = () => {
    if (currentReservation) {
      dispatch(fetchCancelReservation(currentReservation.id));
    }
    setIsEditModalOpen(false);
    setShowModal(false);
    setTokens("");
  };
  const handleShowModal = () => {
    setShowModal(true);
  };
  const handleCloseModal = () => {
    setShowModal(false);
  };
  const changeDate = (date) => {
    setStartDate(date);
    setCurrentStep(1);
  };
  const chooseNumberOfPeople = (number_of_people) => {
    setNumPeople(number_of_people);
    if (reservation_or_waiting_list === "waiting_list") {
      setCurrentStep(3);
    } else {
      setCurrentStep(2);
      // Hand off to the effect above, which needs the day's zones first.
      if (singlePage) setAutoSelectRoomPending(true);
    }
  };
  const changeTime = (time) => {
    setTime(time);
    setCurrentStep(3);
  };
  function extractNumbers(dictionary) {
    const numbers = [];
    Object.keys(dictionary).forEach((key) => {
      const array = dictionary[key];
      array.forEach((item) => {
        if (item.number) {
          numbers.push(item.number);
        }
      });
    });
    return numbers;
  }
  useEffect(() => {
    const formatDateToYYYYMMDD = (date) => {
      if (!date) return null;
      const d = new Date(date);
      const year = d.getFullYear();
      const month = (d.getMonth() + 1).toString().padStart(2, "0");
      const day = d.getDate().toString().padStart(2, "0");
      return `${year}-${month}-${day}`;
    };
    let formattedStartDate = formatDateToYYYYMMDD(startDate);
    if (
      openTime &&
      openTime.opentime_per_zone &&
      !isLoadingAllTables &&
      !isLoadingReservation
    ) {
      let isChangesTable = false;
      if (selectedTablesSave && currentReservation) {
        const table_numbers_to_compare = extractNumbers(selectedTablesSave);
        const tables_used_list = String(currentReservation.tablesused ?? "")
          .split(",")
          .map((num) => num.trim())
          .filter((num) => num);
        const hasExtraTables = tables_used_list.some(
          (tableNumber) => !table_numbers_to_compare.includes(tableNumber),
        );
        const hasMissingTables = table_numbers_to_compare.some(
          (tableNumber) => !tables_used_list.includes(tableNumber),
        );
        if (hasExtraTables || hasMissingTables) {
          isChangesTable = true;
          setIsTablesChangedManually(true);
        } else {
          isChangesTable = false;
          setIsTablesChangedManually(false);
        }
      }
      let isDifferent = false;
      if (currentReservation) {
        formattedStartDate = formatDateToYYYYMMDD(startDate);
        isDifferent =
          currentReservation.date !== formattedStartDate ||
          Number(currentReservation.number_of_people) !== Number(numPeople) ||
          normalizeRoomSelection(
            currentReservation.table_place_preference?.place_of_table,
            from_restaurant,
          ) !== placeOfTable ||
          currentReservation.time !== time ||
          (currentReservation.full_name ?? "") !== fullName ||
          (currentReservation.email ?? "") !== email ||
          String(currentReservation.phone_number ?? "") !== String(phone) ||
          Number(currentReservation.baby_chair ?? 0) !==
            Number(numBabyChairs) ||
          (currentReservation.restaurant_note ?? "") !==
            (restaurantNote ?? "");
      }
      if (isDifferent || isChangesTable) {
        setIsReservationChanged(true);
      } else {
        setIsReservationChanged(false);
      }
      const diffs = [];
      const cmp = (label, a, b) => {
        const A = (a ?? "").toString().trim();
        const B = (b ?? "").toString().trim();
        if (A !== B)
          diffs.push({
            label,
            A,
            B,
          });
      };
      if (currentReservation) {
        cmp("date", currentReservation.date, formattedStartDate);
        cmp(
          "people",
          currentReservation.number_of_people,
          Number(numPeople),
        );
        cmp(
          "place",
          normalizeRoomSelection(
            currentReservation.table_place_preference?.place_of_table,
            from_restaurant,
          ),
          placeOfTable,
        );
        cmp("time", currentReservation.time, time);
        cmp("name", currentReservation.full_name, fullName);
        cmp("email", currentReservation.email, email);
        cmp("phone", currentReservation.phone_number, phone);
        cmp(
          "baby_chair",
          currentReservation.baby_chair,
          Number(numBabyChairs),
        );
        cmp(
          "accessability",
          currentReservation.accessability,
          accessability === "Cadeira de rodas"
            ? "wheel_chair"
            : "not_needed",
        );
        cmp("brings_pet", Boolean(currentReservation.brings_pet), bringsPet);
        cmp(
          "brings_stroller",
          Boolean(currentReservation.brings_stroller),
          bringsStroller,
        );
        cmp(
          "restaurant_note",
          currentReservation.restaurant_note ?? "",
          restaurantNote ?? "",
        );
      }
      if (diffs.length || isChangesTable || creating) {
        console.log("MARKED MODIFIED BECAUSE:", {
          diffs,
          isChangesTable,
          creating,
        });
      }
      if (isDifferent || isChangesTable || creating) {
        if (typeof setModalReservationModifyReservation === "function") {
          setReservationHasBeenModified(true);
        }
        for (const x of openTime.opentime_per_zone[
          placeOfTable.endsWith("/f") || placeOfTable.endsWith("/b")
            ? placeOfTable.slice(0, -2)
            : placeOfTable
        ] || []) {
          let cleanTime = x.replace(/\/[fb]$/, "");
          if (cleanTime === time) {
            if (x.endsWith("/f")) {
              setFullyBooked(true);
              setIsAlertFullyBookedOrCrowd(true);
            } else if (x.endsWith("/b")) {
              setFullyBooked(false);
              setIsAlertFullyBookedOrCrowd(true);
            } else {
              setIsAlertFullyBookedOrCrowd(false);
            }
          }
        }
        setIsChangesMade(true);
      } else {
        if (typeof setModalReservationModifyReservation === "function") {
          setReservationHasBeenModified(false);
        }
        setIsChangesMade(false);
        setIsAlertFullyBookedOrCrowd(false);
      }
    }
  }, [
    fullName,
    email,
    phone,
    numPeople,
    placeOfTable,
    startDate,
    time,
    token,
    openTime,
    currentReservation,
    selectedTablesSave,
    numBabyChairs,
    accessability,
    restaurantNote,
  ]);
  /* The room select and the time list, built once so the restaurant's compact
     row and the customer widget's step can each place them without the prop
     list being written out twice. */
  const roomControl = openTime ? (
    <CustomSelect
      items={roomOptions}
      onSelectChange={handlePlaceOfTable}
      selectedItem={placeOfTable}
      setUpdate={setUpdate}
      update={update}
      from_restaurant={from_restaurant}
      align={singlePage ? "start" : "center"}
      widgetDark={
        widgetSettings.backgroundColor === "#FFFFFF"
          ? false
          : true
      }
    />
  ) : null;

  const timesControl = openTime ? (
    <ChooseTime
      options={openTime.opentime_per_zone}
      onTimeChange={handleTimeChange}
      time={time}
      timezone={restaurantTimezone}
      current_date={startDate}
      setTime={setTime}
      currentZone={
        placeOfTable.endsWith("/f")
          ? placeOfTable.slice(0, -2)
          : placeOfTable
      }
      editingStartFalse={editingStartFalse}
      reservation={currentReservation}
      update={update}
      from_restaurant={from_restaurant}
      true_create_false_edit={creating}
      changeTime={changeTime}
      people_per_time={openTime.people_per_time}
      placeOfTable={placeOfTable}
      startDate={startDate}
      numPeople={numPeople}
      token={token}
      showModalWarning={showModalWarning}
      setShowModalWarning={setShowModalWarning}
      fullyBooked={fullyBooked}
      setFullyBooked={setFullyBooked}
      widgetMode={widgetMode}
      widgetDark={
        widgetSettings.backgroundColor === "#FFFFFF"
          ? false
          : true
      }
    />
  ) : null;

  return (
    <WidgetScreenFrame
      $widgetMode={widgetMode}
      $fromRestaurant={from_restaurant}
      $backgroundColor={widgetSettings.backgroundColor}
      $widgetDark={widgetDark}
    >
      {shouldRenderReservationForm ? (
        <>
          {showCheck && (
            <ContainerCheck>
              <ModalBackgroundCheck>
                <ToastContainer />
                <AnimatedCheck />
              </ModalBackgroundCheck>
            </ContainerCheck>
          )}

          <>
            <Wrapper
              no_border={no_border}
              from_restaurant={from_restaurant}
              $widgetMode={widgetMode}
              $backgroundColor={widgetSettings.backgroundColor}
              $mainColor={widgetSettings.mainColor}
              $radius={widgetSettings.radius}
            >
              {widgetMode && !from_restaurant ? (
                <WidgetHeading>
                  <WidgetCustomTitle $mainColor={widgetSettings.mainColor}>
                    {widgetSettings.title}
                  </WidgetCustomTitle>

                  {widgetSettings.showRestaurantName && (
                    <Title
                      $widgetMode={widgetMode}
                      $mainColor={widgetSettings.mainColor}
                    >
                      {restaurants ? restaurants.restaurant_name : <Loader />}
                    </Title>
                  )}
                </WidgetHeading>
              ) : (
                <>
                  {creating && !from_restaurant && (
                    <>
                      <Eyebrow>
                        {t("ui.screens.reservationScreen.novaReserva")}
                      </Eyebrow>

                      <Title
                        $widgetMode={widgetMode}
                        $mainColor={widgetSettings.mainColor}
                      >
                        {restaurants ? restaurants.restaurant_name : <Loader />}
                      </Title>
                    </>
                  )}
                </>
              )}

              {!singlePage && <StepBar
                widgetMode={widgetMode}
                widgetDark={widgetSettings.backgroundColor.toUpperCase() === "#2F3437"}
                time={time}
                startDate={startDate}
                numPeople={numPeople}
                setNumPeople={setNumPeople}
                changeStep={changeStep}
                currentStep={currentStep}
                placeOfTable={placeOfTable}
                reservation_or_waiting_list={reservation_or_waiting_list}
                timezone={restaurantTimezone}
                from_restaurant={from_restaurant}
                creating={creating}
                mainColor={widgetSettings.mainColor}
              />}

              <StyledCard
                from_restaurant={from_restaurant}
                $widgetMode={widgetMode}
                $backgroundColor={widgetSettings.backgroundColor}
              >
                <FormGrid $single={singlePage}>

                <FormSection
                  single={singlePage}
                  icon={faCalendarAlt}
                  title={t("ui.screens.reservationScreen.sectionDate")}
                >
                {showFormStep(0) &&
                  (singlePage ? (
                    <DatePopoverAnchor ref={datePopoverRef}>
                      <DateField
                        type="button"
                        $open={isDatePickerOpen}
                        onClick={() => setIsDatePickerOpen((open) => !open)}
                      >
                        <span>{selectedDateLabel}</span>
                        <FontAwesomeIcon icon={faCalendarAlt} />
                      </DateField>

                      {isDatePickerOpen && (
                        <DatePopover>
                          <CustomDatePicker
                            selectedDate={startDate}
                            onDateChange={(date) => {
                              changeDate(date);
                              setIsDatePickerOpen(false);
                            }}
                            id={restaurant_id}
                            mainColor={widgetSettings.mainColor}
                            widgetDark={false}
                          />
                        </DatePopover>
                      )}
                    </DatePopoverAnchor>
                  ) : (
                    <CustomDatePicker
                      selectedDate={startDate}
                      onDateChange={(date) => changeDate(date)}
                      id={restaurant_id}
                      mainColor={widgetSettings.mainColor}
                      widgetDark={
                        widgetSettings.backgroundColor === "#FFFFFF"
                          ? false
                          : true
                      }
                    />
                  ))}

                </FormSection>

                <FormSection
                  single={singlePage}
                  icon={faUsers}
                  title={t("ui.screens.reservationScreen.sectionPeople")}
                >
                {showFormStep(1) && (
                  <NumberOfPeopleSelector
                    numPeople={numPeople}
                    setNumPeople={chooseNumberOfPeople}
                    from_restaurant={from_restaurant}
                    limit_people_reservation={restaurantReservationLimit}
                    widgetMode={widgetMode}
                    widgetDark={
                      widgetSettings.backgroundColor === "#FFFFFF"
                        ? false
                        : true
                    }
                  />
                )}

                </FormSection>

                <FormSection
                  single={singlePage}
                  icon={faClock}
                  title={t("ui.screens.reservationScreen.sectionTimeRoom")}
                  span
                  bare={singlePage}
                >
                {showFormStep(2) &&
                  (singlePage ? (
                    <PairRow>
                      <FieldBlock $disabled={!dateChosen}>
                        <FieldLabel>
                          <FontAwesomeIcon icon={faHouse} />
                          {t("ui.screens.reservationScreen.sala")}
                        </FieldLabel>

                        {/* The rooms arrive with the day's opening times, so
                            before a date there is nothing to list. An empty
                            field holds the column's shape rather than leaving
                            a label hanging over nothing. */}
                        {roomControl || (
                          <DateField type="button" disabled>
                            <span>
                              {t("ui.screens.reservationScreen.sala")}
                            </span>
                            <FontAwesomeIcon icon={faHouse} />
                          </DateField>
                        )}
                      </FieldBlock>

                      {reservation_or_waiting_list === "reservation" && (
                        <FieldBlock
                          ref={timePopoverRef}
                          $disabled={!dateChosen}
                        >
                          <FieldLabel>
                            <FontAwesomeIcon icon={faClock} />
                            {t("ui.screens.reservationScreen.horas")}
                          </FieldLabel>

                          <DatePopoverAnchor>
                            <DateField
                              type="button"
                              disabled={!dateChosen}
                              $open={isTimePickerOpen}
                              onClick={() =>
                                setIsTimePickerOpen((open) => !open)
                              }
                            >
                              <span>
                                {time ||
                                  t("ui.screens.reservationScreen.horas")}
                              </span>
                              <FontAwesomeIcon icon={faClock} />
                            </DateField>

                            {isTimePickerOpen && dateChosen && (
                              <TimePopover>{timesControl}</TimePopover>
                            )}
                          </DatePopoverAnchor>
                        </FieldBlock>
                      )}

                      {!dateChosen && (
                        <PairHint>
                          <FontAwesomeIcon icon={faCalendarAlt} />
                          {t("ui.screens.reservationScreen.pickDateFirst")}
                        </PairHint>
                      )}
                    </PairRow>
                  ) : (
                    <Row>
                      <Col
                        xs={12}
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <div
                          style={{
                            borderBottom: "1px solid #99B0AD",
                            paddingBottom: "3px",
                            marginBottom: "3px",
                            color: "#99B0AD",
                            width: "200px",
                            height: "25px",
                          }}
                        >
                          <FontAwesomeIcon
                            icon={faHouse}
                            style={{ color: "#99B0AD" }}
                          />{" "}
                          {t("ui.screens.reservationScreen.sala")}
                        </div>
                      </Col>

                      <Col
                        xs={12}
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          width: "100%",
                        }}
                      >
                        {roomControl}
                      </Col>

                      {reservation_or_waiting_list === "reservation" &&
                        openTime && (
                          <Row
                            style={{ margin: "0", padding: "0", width: "100%" }}
                          >
                            <Col
                              xs={12}
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              <div
                                style={{
                                  borderBottom: "1px solid #99B0AD",
                                  paddingBottom: "3px",
                                  color: "#99B0AD",
                                  width: "200px",
                                  height: "25px",
                                }}
                              >
                                <FontAwesomeIcon
                                  icon={faClock}
                                  style={{ color: "#99B0AD" }}
                                />{" "}
                                {t("ui.screens.reservationScreen.horas")}
                              </div>
                            </Col>

                            <Col
                              xs={12}
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              {timesControl}
                            </Col>
                          </Row>
                        )}
                    </Row>
                  ))}
                </FormSection>

                <FormSection
                  single={singlePage}
                  icon={faNoteSticky}
                  title={t("ui.screens.reservationScreen.sectionDetails")}
                  span
                >
                {showFormStep(3) && (
                  <>
                    <StepThreeReservations
                      fullName={fullName}
                      setFullName={setFullName}
                      countryCodeNumber={countryCodeNumber}
                      setCountryCodeNumber={setCountryCodeNumber}
                      phoneWithoutCountryCode={phoneWithoutCountryCode}
                      setPhoneWithoutCountryCode={setPhoneWithoutCountryCode}
                      Extras={Extras}
                      isExtrasOpen={isExtrasOpen}
                      handleExtras={handleExtras}
                      babyChairs={babyChairs}
                      DivFlexStart={DivFlexStart}
                      setBabyChairs={setBabyChairs}
                      DivFlexEnd={DivFlexEnd}
                      ScrollInputOptions={ScrollInputOptions}
                      numBabyChairs={numBabyChairs}
                      existingBabyChairs={restaurants?.number_of_babychairs}
                      handleBabyChange={handleBabyChange}
                      limitPeopleBaby={limitPeopleBaby}
                      isMessageOpen={isMessageOpen}
                      setIsMessageOpen={setIsMessageOpen}
                      isAccessOpen={isAccessOpen}
                      message={message}
                      setMessage={setMessage}
                      maxMessageLength={maxMessageLength}
                      CustomSelect={CustomSelect}
                      accessabilities={accessabilities}
                      askPetFriendly={Boolean(restaurants?.ask_pet_friendly)}
                      askBabyStroller={Boolean(
                        restaurants?.ask_baby_stroller,
                      )}
                      bringsPet={bringsPet}
                      setBringsPet={setBringsPet}
                      bringsStroller={bringsStroller}
                      setBringsStroller={setBringsStroller}
                      setIsAccessOpen={setIsAccessOpen}
                      setAccessability={setAccessability}
                      ActionButtons={ActionButtons}
                      goBack={goBack}
                      accessability={accessability}
                      setShowTermsAndConditions={setShowTermsAndConditions}
                      handleSubmit={handleSubmit}
                      handleEdit={handleEdit}
                      phoneWS={showFieldErrors && phoneWS}
                      setEmail={setEmail}
                      email={email}
                      emailWS={showFieldErrors && emailWS}
                      has_email={has_email}
                      fullNameWS={showFieldErrors && fullNameWS}
                      true_create_false_edit={creating}
                      acceptTerms={acceptTerms}
                      setAcceptTerms={setAcceptTerms}
                      acceptTermsWS={showFieldErrors && acceptTermsWS}
                      from_restaurant={from_restaurant}
                      creating={creating}
                      handleShowModal={handleShowModal}
                      restaurantNote={restaurantNote}
                      setRestaurantNote={setRestaurantNote}
                      widgetMode={widgetMode}
                      widgetDark={
                        widgetSettings.backgroundColor === "#FFFFFF"
                          ? false
                          : true
                      }
                      mainColor={widgetSettings.mainColor}
                      sub_lvl={restaurantSubscriptionLevel}
                    />

                    {!from_restaurant && (
                      <TermsRow>
                        {creating ? (
                          <>
                            {creating && !from_restaurant && (
                              <TermsBox
                                $invalid={showFieldErrors && !!acceptTermsWS}
                                $widgetMode={widgetMode}
                                style={{
                                  width: "auto",
                                  flex: "1 1 0",
                                  minWidth: 0,
                                  margin: 0,
                                }}
                              >
                                <TermsContent
                                  $widgetMode={widgetMode}
                                  style={{ alignItems: "center" }}
                                >
                                  <input
                                    type="checkbox"
                                    checked={acceptTerms}
                                    onChange={() =>
                                      setAcceptTerms(!acceptTerms)
                                    }
                                  />
                                  <span style={{ minWidth: 0 }}>
                                    {t(
                                      "ui.screens.reservationScreen.liEAceitoOs",
                                    )}{" "}
                                    <a
                                      onClick={(event) => {
                                        event.preventDefault();
                                        setShowTermsAndConditions(true);
                                      }}
                                    >
                                      {t(
                                        "ui.screens.reservationScreen.termosECondicoes",
                                      )}
                                    </a>
                                    .
                                  </span>
                                </TermsContent>
                              </TermsBox>
                            )}

                            <div
                              style={{
                                flex: "0 0 auto",
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "flex-end",
                                gap: "8px",
                              }}
                            >
                              <ModernButton
                                color={
                                  widgetMode
                                    ? widgetSettings.mainColor
                                    : "#EE754C"
                                }
                                onClick={(e) => handleSubmit(e)}
                                style={{
                                  whiteSpace: "nowrap",
                                }}
                              >
                                {t(
                                  "ui.screens.reservationScreen.solicitarReserva",
                                )}
                              </ModernButton>
                              {createReservationFailed && (
                                <div
                                  role="alert"
                                  style={{
                                    color: "#c0392b",
                                    fontSize: "0.9rem",
                                    maxWidth: "420px",
                                    textAlign: "right",
                                  }}
                                >
                                  {customerPrepaymentRequired
                                    ? t(
                                        "ui.screens.reservationScreen.prepaymentStartFailed",
                                      )
                                    : t(
                                        "ui.screens.reservationScreen.reservationCreateFailed",
                                      )}
                                </div>
                              )}
                            </div>
                          </>
                        ) : (
                          <div
                            style={{
                              width: "100%",
                              display: "flex",
                              justifyContent: "flex-end",
                            }}
                          >
                            <ModernButton
                              color={
                                widgetMode
                                  ? widgetSettings.mainColor
                                  : "#EE754C"
                              }
                              onClick={(e) => handleEdit(e)}
                              style={{
                                whiteSpace: "nowrap",
                              }}
                            >
                              {t(
                                "ui.screens.reservationScreen.solicitarAlteracaoDeReserva",
                              )}
                            </ModernButton>
                          </div>
                        )}
                      </TermsRow>
                    )}

                    {creating && from_restaurant && (
                      <AssignmentRow>
                        <SectionLabel>
                          <TableSvgIcon
                            width={12}
                            height={12}
                            strokeColor="#a8bbb8"
                          />
                          {t("ui.screens.reservationScreen.mesas")}
                        </SectionLabel>

                        <Segmented>
                          {[
                            {
                              value: "Atribuição automática de mesas",
                              label: t("ui.screens.reservationScreen.tablesAuto"),
                            },
                            {
                              value: "Atribuição manual de mesas",
                              label: t("ui.screens.reservationScreen.tablesManual"),
                            },
                          ].map((option) => (
                            <SegmentedOption
                              key={option.value}
                              type="button"
                              $active={autoOrManualTables === option.value}
                              onClick={() => setAutoOrManualTables(option.value)}
                            >
                              {option.label}
                            </SegmentedOption>
                          ))}
                        </Segmented>

                        {formDataReady &&
                          numPeople !== 0 &&
                          autoOrManualTables ===
                            "Atribuição manual de mesas" &&
                          Array.isArray(tablesUsed) && (
                            <TablesWrapper>
                              <TableSvgIcon
                                width={18}
                                height={18}
                                strokeColor="#99B0AD"
                              />

                              {chosenTableNames && (
                                <TableNames>{chosenTableNames}</TableNames>
                              )}

                              <SmallButton
                                type="button"
                                disabled={!canPickTables}
                                title={
                                  canPickTables
                                    ? undefined
                                    : t(
                                        "ui.screens.reservationScreen.pickTimeFirst",
                                      )
                                }
                                onClick={() => handleShowTablesModal()}
                              >
                                {t("ui.screens.reservationScreen.mesas")}
                              </SmallButton>
                            </TablesWrapper>
                          )}
                      </AssignmentRow>
                    )}

                  </>
                )}

                </FormSection>

                </FormGrid>

                {showFormStep(3) &&
                  (formDataReady ? (
                    from_restaurant && (
                      <FormActions>
                        {creating ? (
                          <>
                            {!verifyReservationFields && (
                              <ActionHint>
                                {t("ui.screens.reservationScreen.missingFields")}
                              </ActionHint>
                            )}

                            {verifyReservationFields ? (
                              <ModernButton
                                color="#EE754C"
                                onClick={(e) => handleCheckWarningBeforeEdit(e)}
                              >
                                {t("ui.screens.reservationScreen.criarReserva")}
                              </ModernButton>
                            ) : (
                              <ModernButton
                                color="#99B0AD"
                                style={{ cursor: "not-allowed" }}
                                disabled
                              >
                                {t(
                                  "ui.screens.reservationScreen.criarReserva2",
                                )}
                              </ModernButton>
                            )}
                          </>
                        ) : (
                          currentReservation &&
                          isWithinOneDay(currentReservation.date) && (
                            <>
                              <ModernButton
                                color="#99B0AD"
                                onClick={(e) => handleShowModal(e)}
                              >
                                {t(
                                  "ui.screens.reservationScreen.cancelarReserva",
                                )}
                              </ModernButton>

                              {isChangesMade && (
                                <ModernButton
                                  color="#EE754C"
                                  onClick={(e) =>
                                    handleCheckWarningBeforeEdit(e)
                                  }
                                >
                                  {t(
                                    "ui.screens.reservationScreen.guardarAlteracoes",
                                  )}
                                </ModernButton>
                              )}
                            </>
                          )
                        )}
                      </FormActions>
                    )
                  ) : (
                    <Loader />
                  ))}

                {currentStep === 4 && (
                  <>
                    {isLoading ? (
                      <h2>
                        <Loader />
                      </h2>
                    ) : String(error?.error ?? "").includes(
                        "reservation-exists",
                      ) ? (
                      <>
                        <h2>
                          <FontAwesomeIcon
                            size="xl"
                            icon={faTriangleExclamation}
                            style={{
                              color: "#f3e335",
                              marginRight: "15px",
                            }}
                          />
                          {t(
                            "ui.screens.reservationScreen.jaTensUmPedidoDeReserva",
                          )}
                        </h2>
                      </>
                    ) : (
                      <h2>
                        {t(
                          "ui.screens.reservationScreen.porFavorAtualizarAPagina",
                        )}
                      </h2>
                    )}
                  </>
                )}
              </StyledCard>

              <TermsAndConditions
                showTermsAndConditions={showTermsAndConditions}
                setSetShowTermsAndConditions={handleTermsAndConditionsFalse}
              />
            </Wrapper>
          </>

          <ConfirmationModal
            show={showPrepaymentConfirmation}
            onHide={() => setShowPrepaymentConfirmation(false)}
            onConfirm={(e) => handleSubmit(e, true)}
            title={t(
              "ui.screens.reservationScreen.prepaymentRequiredTitle",
            )}
            body={
              <>
                <p>
                  {t("ui.screens.reservationScreen.prepaymentDueNow", {
                    amount: formatPrepaymentMoney(prepaymentTotalCents),
                  })}
                </p>
                {restaurants?.prepayment_charge_type !== "fixed" && (
                  <p>
                    {t(
                      "ui.screens.reservationScreen.prepaymentPerPersonCalculation",
                      {
                        unit: formatPrepaymentMoney(prepaymentUnitAmountCents),
                        people: Number(numPeople) || 0,
                        total: formatPrepaymentMoney(prepaymentTotalCents),
                      },
                    )}
                  </p>
                )}
                <p>
                  {t("ui.screens.reservationScreen.prepaymentFreeCancel", {
                    hours:
                      Number(
                        restaurants?.prepayment_free_cancellation_hours,
                      ) || 0,
                  })}
                </p>
                <p>
                  {t("ui.screens.reservationScreen.prepaymentLateCancel")}
                </p>
                <p>
                  {t("ui.screens.reservationScreen.prepaymentRestaurantCancel")}
                </p>
                <p style={{ marginBottom: "12px" }}>
                  {t("ui.screens.reservationScreen.prepaymentPaymentMethods")}
                </p>
                <label
                  style={{
                    display: "flex",
                    alignItems: "flex-start",
                    gap: "9px",
                    cursor: "pointer",
                    lineHeight: 1.35,
                    margin: 0,
                  }}
                >
                  <input
                    type="checkbox"
                    checked={acceptPrepaymentPolicy}
                    onChange={(event) =>
                      setAcceptPrepaymentPolicy(event.target.checked)
                    }
                    style={{ marginTop: "3px", flexShrink: 0 }}
                  />
                  <span>
                    {t(
                      "ui.screens.reservationScreen.prepaymentPolicyAcceptance",
                    )}
                  </span>
                </label>
              </>
            }
            confirmLabel={t("ui.screens.reservationScreen.payAndReserve", {
              amount: formatPrepaymentMoney(prepaymentTotalCents),
            })}
            cancelLabel={t("common.cancel")}
            confirmColor="#ee754c"
            cancelColor="#99b0ad"
            confirmDisabled={!acceptPrepaymentPolicy}
          />

          <ConfirmationModal
            show={showModalWarning}
            onHide={() => setShowModalWarning(false)}
            onConfirm={(e) => {
              setShowModalWarning(false);
              if (creating) {
                handleSubmit(e);
              } else {
                handleEdit(e);
              }
            }}
            title={t("ui.screens.reservationScreen.mesasInsuficientes")}
            body={
              <>
                {from_restaurant &&
                  !creating &&
                  (reservationStatus === "pending_restaurant" ||
                    reservationStatus === "edited") && (
                    <div
                      style={{
                        paddingBottom: "10px",
                      }}
                    >
                      {t(
                        "ui.screens.reservationScreen.aceitarReservaENotificarCliente",
                      )}
                      <SwitchOnAndOff
                        clienteAndOff
                        isOn={accept_and_notify_client}
                        handleToggle={() =>
                          setAccept_and_notify_client(!accept_and_notify_client)
                        }
                      />
                    </div>
                  )}

                {fullyBooked ? (
                  <div
                    style={{
                      color: "red",
                    }}
                  >
                    {t(
                      "ui.screens.reservationScreen.aSalaEscolhidaEncontraSeLotada",
                    )}
                    <br />
                    {t(
                      "ui.screens.reservationScreen.aoContinuarNaoSeraoAtribuidasMesas",
                    )}
                  </div>
                ) : (
                  <div
                    style={{
                      color: "#d9c834",
                    }}
                  >
                    {t(
                      "ui.screens.reservationScreen.cadaHorarioDisponivelAceitaAte",
                    )}{" "}
                    {restaurantPeoplePerTime}
                    {t("ui.screens.reservationScreen.pessoas")}
                    <br />
                    {t(
                      "ui.screens.reservationScreen.aoContinuarIraUltrapassarEsteLimite",
                    )}
                    <br />
                    {t(
                      "ui.screens.reservationScreen.alterarONumeroMaximoDePessoas",
                    )}
                  </div>
                )}
              </>
            }
            confirmLabel={creating ? t("ui.i18nCleanup2.criarReserva") : t("common.save")}
            cancelLabel={fullyBooked ? t("ui.i18nCleanup.viewTables") : t("ui.i18nCleanup2.naoAvancar")}
            confirmColor="#EE754C"
            cancelColor={fullyBooked ? "#99B0AD" : "#EE754C"}
            onCancel={() => {
              setShowModalWarning(false);
              handleShowTablesModal(true);
            }}
          />

          <ConfirmationModal
            show={accept_edit_modal}
            onHide={() => setAccept_edit_modal(false)}
            onConfirm={(e) => {
              setAccept_edit_modal(false);
              handleEdit(e);
            }}
            title={t("ui.screens.reservationScreen.mesasInsuficientes")}
            body={
              <>
                {t(
                  "ui.screens.reservationScreen.aceitarReservaENotificarCliente2",
                )}{" "}
                <SwitchOnAndOff
                  isOn={accept_and_notify_client}
                  handleToggle={() =>
                    setAccept_and_notify_client(!accept_and_notify_client)
                  }
                />
              </>
            }
            confirmLabel={t("common.save")}
            cancelLabel={t("ui.i18nCleanup2.naoGuardar")}
            confirmColor="#EE754C"
            cancelColor="#99b0ad "
            onCancel={() => {
              setAccept_edit_modal(false);
            }}
          />

          {showDateModal && (
            <ModalBackgroundToCustomDate>
              <CustomDateContainer onHide={handleCloseDateModal}>
                <CustomDatePicker
                  selectedDate={startDate}
                  onDateChange={(date) => changeDate(date)}
                  id={restaurant_id}
                  handleCloseDateModal={handleCloseDateModal}
                  mainColor={widgetSettings.mainColor}
                />
              </CustomDateContainer>
            </ModalBackgroundToCustomDate>
          )}

          {/* Tied to the same condition as the dialog itself: when the table
              list failed to load, `tables` is false and TablesModal renders
              nothing, so an overlay here would dim the screen with no dialog
              on it and no way to dismiss it. */}
          {showTablesModal && tables && <ModalOverlay />}

          {tables && (
            <TablesModal
              show={showTablesModal}
              tables_list={tables}
              onClose={() => setShowTablesModal(false)}
              initialSelectedTables={usedTablesDic}
              token={token}
              id={restaurant_id}
              numPeople={numPeople}
              time={time}
              date={startDate}
              handleTablesUsedChange={handleTablesUsedChange}
              setSelectedTablesSave={(value) => setSelectedTablesSave(value)}
              setPlaceOfTable={(value) => setPlaceOfTable(value)}
              setEnoughSeatsReservation={setEnoughSeatsReservation}
              placeOfTable={placeOfTable}
              reservation={currentReservation}
            />
          )}

          <ConfirmationModal
            show={showModal}
            onHide={handleCloseModal}
            onConfirm={handleCancel}
            title={t("ui.screens.reservationScreen.eliminarReserva")}
            body={t("ui.i18nCleanup.deleteReservationConfirm")}
            confirmLabel={isLoadingCancel ? <Loader /> : t("ui.screens.reservationScreen.eliminarReserva")}
            cancelLabel={t("ui.i18nCleanup.doNotDelete")}
            confirmColor="#ee754c"
            cancelColor="#99B0AD"
          />

          <ConfirmationModal
            show={modalReservationModifyReservation}
            onHide={() => {
              setModalReservationModifyReservation(false);
              setIsEditModalOpen(false);
            }}
            onConfirm={(e) => {
              setModalReservationModifyReservation(false);
              handleEdit(e);
            }}
            title={t("ui.screens.reservationScreen.alteracoesPorGuardar")}
            body={t("ui.i18nCleanup.reservationChangesUnsaved")}
            confirmLabel={t("ui.screens.reservationScreen.guardarAlteracoes")}
            cancelLabel={t("ui.i18nCleanup.closeWithoutSaving")}
            confirmColor="#ee754c"
            cancelColor="#99B0AD"
          />

          <ConfirmationModal
            show={notifyCustomerModal}
            onHide={() => {
              if (isSubmittingNotifyChoice) return;
              setNotifyCustomerModal(false);
            }}
            title={t("ui.screens.reservationScreen.notificarCliente")}
            body={
              <>
                {t(
                  "ui.screens.reservationScreen.aReservaFoiAlteradaPeloRestaurante",
                )}
                <br />
                {t(
                  "ui.screens.reservationScreen.desejaEnviarUmaMensagemAoCliente",
                )}
              </>
            }
            cancelLabel={
              isSubmittingNotifyChoice ? t("ui.i18nCleanup2.aGuardar") : t("ui.i18nCleanup2.guardarSemAvisar")
            }
            confirmLabel={
              isSubmittingNotifyChoice
                ? t("ui.i18nCleanup2.aEnviar")
                : t("ui.i18nCleanup2.simNotificarCliente")
            }
            cancelColor="#99B0AD"
            confirmColor="#EE754C"
            onCancel={() => handleNotifyCustomerChoice(false)}
            onConfirm={() => handleNotifyCustomerChoice(true)}
          />

          <ConfirmationModal
            show={modalWarningNotEnoughSeats}
            onHide={() => setModalWarningNotEnoughSeats(false)}
            onConfirm={(e) => {
              setModalWarningNotEnoughSeats(false);
              if (creating) {
                handleSubmit(e);
              } else {
                handleEdit(e);
              }
            }}
            title={<>{t("ui.screens.reservationScreen.mesasInsuficientes")}</>}
            body={
              <>
                {from_restaurant &&
                  !creating &&
                  (reservationStatus === "pending_restaurant" ||
                    reservationStatus === "edited") && (
                    <div
                      style={{
                        paddingBottom: "10px",
                      }}
                    >
                      {t(
                        "ui.screens.reservationScreen.aceitarReservaENotificarCliente3",
                      )}{" "}
                      <SwitchOnAndOff
                        isOn={accept_and_notify_client}
                        handleToggle={() =>
                          setAccept_and_notify_client(!accept_and_notify_client)
                        }
                      />
                    </div>
                  )}

                <div>
                  {t(
                    "ui.screens.reservationScreen.naoForamAtribuidasMesasSuficientes",
                  )}
                </div>
                <div>
                  {t(
                    "ui.screens.reservationScreen.aoContinuarNaoHaveraLugaresSuficientes",
                  )}
                </div>
              </>
            }
            confirmLabel={creating ? t("ui.i18nCleanup2.criarReserva") : t("common.save")}
            cancelLabel={t("ui.i18nCleanup.viewTables")}
            confirmColor="#EE754C"
            cancelColor="#99B0AD"
            onCancel={() => {
              setModalWarningNotEnoughSeats(false);
              setShowTablesModal(true);
            }}
          />
        </>
      ) : hasEditLoadError ? (
        <div
          style={{
            width: "100%",
            minHeight: "200px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            gap: "10px",
            padding: "20px",
            textAlign: "center",
          }}
        >
          <strong>{t("ui.i18nCleanup.couldNotLoadReservation")}</strong>
          <span>{t("ui.i18nCleanup.closeWindowAndTryAgain")}</span>
        </div>
      ) : creating || isEditModalOpen ? (
        <div
          style={{
            width: "100%",
            height: "200px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: "10px",
          }}
        >
          <Loader theSize="big" />
        </div>
      ) : (
        <></>
      )}

      {/* Only on the surfaces a diner reaches on their own: the embedded widget
          and the public booking link. This same component is reused inside the
          restaurant's screens and inside the guest's own edit modal (no_border),
          and the mark has no business appearing there. */}
      {isDinerFacingSurface && (
        <SoupAttribution
          restaurant={restaurants}
          source={widgetMode ? "widget" : "booking"}
        />
      )}
    </WidgetScreenFrame>
  );
};
export default ReservationScreen;
/* The terms and the submit button share a line where there is room for both.
   On a phone there is not, and an ellipsis through the sentence somebody is
   agreeing to - "I have read an..." - is not something to ship. Below 520px
   the two stack and the text is shown in full. */
const TermsRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
  margin-top: 1rem;
  flex-wrap: nowrap;

  @media (max-width: 520px) {
    flex-wrap: wrap;
    align-items: stretch;
    gap: 10px;

    /* Wrapping alone is not enough: the terms box can shrink to nothing, so it
       stays on the line and squeezes its sentence into four lines instead.
       Each child claims the full width and they sit one above the other. */
    > * {
      flex: 1 1 100% !important;
    }
  }
`;

const TermsBox = styled.div`
  width: 100%;
  border: ${({ $invalid }) =>
    $invalid
      ? "1px solid #d94b4b"
      : "1px solid var(--widget-border-color, #d8dddb)"};
  border-radius: ${({ $widgetMode }) => ($widgetMode ? "8px" : "10px")};
  padding: ${({ $widgetMode }) => ($widgetMode ? "8px 9px" : "10px 12px")};
  box-sizing: border-box;
  background: ${({ $invalid }) =>
    $invalid ? "rgba(217, 75, 75, 0.04)" : "transparent"};
`;
const TermsContent = styled.label`
  width: 100%;
  display: flex;
  align-items: flex-start;
  gap: 9px;
  margin: 0;
  color: var(--widget-muted-text, #4f5f5b);
  font-size: ${({ $widgetMode }) => ($widgetMode ? "12px" : "14px")};
  line-height: 1.35;
  cursor: pointer;

  input {
    flex: 0 0 auto;
    margin-top: 2px;
  }

  span {
    min-width: 0;
  }

  a {
    color: var(--widget-main-color, #ee754c);
    cursor: pointer;
    text-decoration: underline;
    font-weight: 650;
  }

  @media (max-width: 420px), (max-height: 640px) {
    font-size: 12px;
  }
`;
